"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[739],{

/***/ 324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* reexport */ CustomFilters; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./common/core-components/custom-filters/custom-filters.tsx

function CustomFilters(param) {
    var filters = param.filters;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: filters
    });
}

;// CONCATENATED MODULE: ./common/core-components/custom-filters/index.ts



/***/ }),

/***/ 6147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ HubsMultiSelect; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./common/i18n/index.ts + 17 modules
var i18n = __webpack_require__(2948);
// EXTERNAL MODULE: ./common/ui-components/index.ts + 730 modules
var ui_components = __webpack_require__(8389);
// EXTERNAL MODULE: ./utils/index.ts + 32 modules
var utils = __webpack_require__(5301);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./common/core-components/multi-select/index.ts + 8 modules
var multi_select = __webpack_require__(5358);
// EXTERNAL MODULE: ./common/core-components/hubs-multi-select/intl/index.ts + 4 modules
var intl = __webpack_require__(9224);
;// CONCATENATED MODULE: ./common/core-components/hubs-multi-select/hubs-multi-select.tsx







function HubsMultiSelect(param) {
    var _hubs = param.hubs, hubs = _hubs === void 0 ? [] : _hubs, _selectedHubIds = param.selectedHubIds, selectedHubIds = _selectedHubIds === void 0 ? [] : _selectedHubIds, _setSearchedHubIds = param.setSearchedHubIds, setSearchedHubIds = _setSearchedHubIds === void 0 ? utils/* noop */.ZT : _setSearchedHubIds, _onChange = param.onChange, onChange = _onChange === void 0 ? utils/* noop */.ZT : _onChange;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var options = (0,react.useMemo)(function() {
        return hubs.map(function(hub) {
            return {
                value: hub.id,
                label: hub.alias
            };
        });
    }, [
        hubs
    ]);
    var value = (0,react.useMemo)(function() {
        return options.filter(function(option) {
            return selectedHubIds.includes(option.value);
        });
    }, [
        options,
        selectedHubIds
    ]);
    var allHubsIds = hubs.map(function(hub) {
        return hub.id;
    });
    var handleChange = function(selectedHubs) {
        var ref;
        var hubIds = (ref = selectedHubs === null || selectedHubs === void 0 ? void 0 : selectedHubs.map(function(item) {
            return item.value;
        })) !== null && ref !== void 0 ? ref : [];
        if (!hubIds.length) {
            onChange(allHubsIds);
            setSearchedHubIds(allHubsIds);
            return;
        }
        onChange(hubIds);
        setSearchedHubIds(hubIds);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Box */.xu, {
        w: "24.19rem",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(multi_select/* MultiSelect */.N, {
            allValuesLabel: formatMessage({
                id: intl/* hubsMultiSelectIntlIds.allValuesLabel */.HE.allValuesLabel
            }),
            name: "hubs",
            onChange: handleChange,
            options: options,
            placeholder: formatMessage({
                id: intl/* hubsMultiSelectIntlIds.placeholder */.HE.placeholder
            }),
            noOptionsLabel: formatMessage({
                id: intl/* hubsMultiSelectIntlIds.noOptionsLabel */.HE.noOptionsLabel
            }),
            value: value
        })
    });
}

;// CONCATENATED MODULE: ./common/core-components/hubs-multi-select/index.ts



/***/ }),

/***/ 3937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w4": function() { return /* reexport */ ChangeOrAssignTripRiderModal; },
  "Dv": function() { return /* reexport */ ContentLayout; },
  "IT": function() { return /* reexport */ Countdown; },
  "nx": function() { return /* reexport */ custom_filters/* CustomFilters */.n; },
  "Dw": function() { return /* reexport */ DateRangePicker; },
  "LM": function() { return /* reexport */ DeliverySearchInput; },
  "Xp": function() { return /* reexport */ hubs_multi_select/* HubsMultiSelect */.X; },
  "zr": function() { return /* reexport */ LabeledStrongContent; },
  "d8": function() { return /* reexport */ ManualOrAutomaticRiderAssignment; },
  "DY": function() { return /* reexport */ base_modal/* ModalProvider */.DY; },
  "rM": function() { return /* reexport */ ModalityTag; },
  "e9": function() { return /* reexport */ OnActionModal; },
  "tl": function() { return /* reexport */ Pagination; },
  "y3": function() { return /* reexport */ SpinnerLoading; },
  "Nj": function() { return /* reexport */ StatusTag; },
  "_3": function() { return /* reexport */ StrongLabeledContentWithIcon; },
  "iA": function() { return /* reexport */ Table; },
  "LL": function() { return /* reexport */ TitlePage; },
  "JU": function() { return /* reexport */ TripActionButton; },
  "GT": function() { return /* reexport */ TripRiderAssign; },
  "al": function() { return /* reexport */ TripRiderInfos; },
  "G1": function() { return /* reexport */ UploadFile; },
  "yB": function() { return /* reexport */ useOnErrorToast; },
  "dV": function() { return /* reexport */ useOnLoadingToast; },
  "kK": function() { return /* reexport */ useOnSuccessToast; },
  "FV": function() { return /* reexport */ useOnWarningToast; },
  "Rl": function() { return /* reexport */ useUploadFileActions; },
  "q4": function() { return /* reexport */ useUploadFileState; },
  "fZ": function() { return /* reexport */ withRouteAccess; }
});

// UNUSED EXPORTS: MultiSelect, TableHeader, usePagination

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./common/ui-components/index.ts + 730 modules
var ui_components = __webpack_require__(8389);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./common/core-components/content-layout/content-layout.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n  scrollbar-width: none;\n  -webkit-overflow-scrolling: touch;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledTabList = (0,ui_components/* styled */.zo)(ui_components/* TabList */.td)(_templateObject());

;// CONCATENATED MODULE: ./common/core-components/content-layout/tabs-header/tabs-header.tsx


function TabsHeader(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Tab */.OK, {
                children: item.label
            }, item.label);
        })
    });
}

;// CONCATENATED MODULE: ./common/core-components/content-layout/tabs-header/index.ts


;// CONCATENATED MODULE: ./common/core-components/content-layout/content-layout.tsx




function ContentLayout(param) {
    var customFilters = param.customFilters, selectedTabIndex = param.selectedTabIndex, _items = param.items, items = _items === void 0 ? [] : _items, _hasTabs = param.hasTabs, hasTabs = _hasTabs === void 0 ? true : _hasTabs, onStatusChange = param.onStatusChange;
    var _label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Tabs */.mQ, {
        display: "flex",
        defaultIndex: selectedTabIndex,
        flex: 1,
        flexDir: "column",
        onChange: onStatusChange,
        w: "100%",
        isLazy: true,
        children: [
            hasTabs ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                wrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabList, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsHeader, {
                            items: items
                        })
                    }),
                    customFilters
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Flex */.kC, {
                justifyContent: "flex-end",
                children: customFilters
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* TabPanels */.nP, {
                display: "flex",
                flex: 1,
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* TabPanel */.x4, {
                        display: "flex",
                        flex: 1,
                        pb: 0,
                        pt: 4,
                        px: 0,
                        w: "inherit",
                        children: item.content
                    }, (_label = item.label) !== null && _label !== void 0 ? _label : index);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./common/core-components/content-layout/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./common/i18n/index.ts + 17 modules
var i18n = __webpack_require__(2948);
// EXTERNAL MODULE: ./utils/index.ts + 32 modules
var utils = __webpack_require__(5301);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./common/core-components/countdown/countdown.constants.ts
var REFRESH_COUNTDOWN_INTERVAL = 1000;
var MEDIUM_WARNING_VALUE = "10:00";
var HIGH_WARNING_VALUE = "05:00";

// EXTERNAL MODULE: ./common/core-components/countdown/intl/index.ts + 1 modules
var intl = __webpack_require__(9930);
;// CONCATENATED MODULE: ./common/core-components/countdown/use-countdown.hook.ts



function useCountdown(param) {
    var startFrom = param.startFrom;
    var initialDiff = new Date(startFrom).getTime() - new Date().getTime();
    var ref = (0,react.useState)(Math.abs(initialDiff)), diff = ref[0], setDiff = ref[1];
    var ref1 = (0,react.useState)(initialDiff < 0), isProgressive = ref1[0], setIsProgressive = ref1[1];
    var refresh = (0,react.useCallback)(function() {
        var countdown = new Date(startFrom).getTime();
        var now = new Date().getTime();
        var diff = countdown - now;
        if (diff < 0) {
            setDiff(Math.abs(diff));
            setIsProgressive(true);
        } else {
            setDiff(diff);
        }
    }, [
        startFrom
    ]);
    (0,react.useEffect)(function refreshCountdown() {
        var interval = setInterval(function() {
            refresh();
        }, REFRESH_COUNTDOWN_INTERVAL);
        return function() {
            return clearInterval(interval);
        };
    }, [
        refresh
    ]);
    return {
        timer: (0,utils/* formatTimer */.NE)(diff),
        isProgressive: isProgressive
    };
}

;// CONCATENATED MODULE: ./common/core-components/countdown/countdown.tsx










function Countdown(param) {
    var startFrom = param.startFrom;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var ref = useCountdown({
        startFrom: startFrom
    }), timer = ref.timer, isProgressive = ref.isProgressive;
    var props = (0,react.useMemo)(function() {
        if (timer <= HIGH_WARNING_VALUE || isProgressive) {
            return (0,utils/* setTextColorByStatus */.MU)(utils/* HIGH_STATUS_COLOR */.v6);
        }
        if (timer <= MEDIUM_WARNING_VALUE) {
            return (0,utils/* setTextColorByStatus */.MU)(utils/* MEDIUM_STATUS_COLOR */.On);
        }
        return (0,utils/* setTextColorByStatus */.MU)(utils/* NORMAL_STATUS_COLOR */.hE);
    }, [
        timer,
        isProgressive
    ]);
    var countdownLabel = isProgressive ? intl/* countdownIntlIds.progressive.label */.lM.progressive.label : intl/* countdownIntlIds.regressive.label */.lM.regressive.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: formatMessage({
            id: countdownLabel
        }, {
            timer: timer
        })
    }));
}

;// CONCATENATED MODULE: ./common/core-components/countdown/index.ts


// EXTERNAL MODULE: ./common/core-components/custom-filters/index.ts + 1 modules
var custom_filters = __webpack_require__(324);
// EXTERNAL MODULE: ./libs/index.ts
var libs = __webpack_require__(4404);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.mjs
var io = __webpack_require__(7094);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.mjs
var md = __webpack_require__(80);
// EXTERNAL MODULE: ./common/core-components/date-range-picker/intl/index.ts + 4 modules
var date_range_picker_intl = __webpack_require__(8017);
;// CONCATENATED MODULE: ./common/core-components/date-range-picker/date-range-picker.tsx










function DateRangePicker(param) {
    var startAt = param.startAt, endAt = param.endAt, onRangePick = param.onRangePick;
    var getInputDisplayValue = function getInputDisplayValue() {
        if (!startDate) return;
        if (!endDate) return startDate.format("DD/MM/YYYY");
        return "".concat(startDate.format("DD/MM/YYYY"), " - ").concat(endDate.format("DD/MM/YYYY"));
    };
    var handleDateClick = function handleDateClick(date) {
        if (date.isBefore(today)) return;
        if (!startDate || startDate && endDate) {
            setStartDate(date);
            setEndDate(null);
        } else {
            if (date.isBefore(startDate)) {
                setEndDate(startDate);
                setStartDate(date);
            } else {
                setEndDate(date);
            }
        }
    };
    var handleClearPeriod = function handleClearPeriod() {
        setStartDate(null);
        setEndDate(null);
        onRangePick("startAt", undefined);
        onRangePick("endAt", undefined);
    };
    var handleRangePick = function handleRangePick() {
        if (!startDate || !endDate) return;
        onRangePick("startAt", startDate.format("YYYY-MM-DD"));
        onRangePick("endAt", endDate.format("YYYY-MM-DD"));
        onClose();
    };
    var ref = (0,react.useRef)(null);
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var ref1 = (0,ui_components/* useDisclosure */.qY)(), isOpen = ref1.isOpen, onOpen = ref1.onOpen, onClose = ref1.onClose;
    var today = (0,libs/* dayjs */.B)().startOf("day");
    var ref2 = (0,react.useState)(today), currentMonth = ref2[0], setCurrentMonth = ref2[1];
    var ref3 = (0,react.useState)(null), startDate = ref3[0], setStartDate = ref3[1];
    var ref4 = (0,react.useState)(null), endDate = ref4[0], setEndDate = ref4[1];
    var ref5 = (0,react.useState)(null), dateOnRange = ref5[0], setDateOnRange = ref5[1];
    (0,react.useEffect)(function() {
        if (startAt && (0,libs/* dayjs */.B)(startAt).isValid()) {
            setStartDate((0,libs/* dayjs */.B)(startAt));
        } else {
            setStartDate(null);
        }
        if (endAt && (0,libs/* dayjs */.B)(endAt).isValid()) {
            setEndDate((0,libs/* dayjs */.B)(endAt));
        } else {
            setEndDate(null);
        }
    }, [
        startAt,
        endAt
    ]);
    var getMonthDays = (0,react.useMemo)(function() {
        var startOfMonth = currentMonth.startOf("month");
        var endOfMonth = currentMonth.endOf("month");
        var days = [];
        for(var day = startOfMonth; day.isBefore(endOfMonth) || day.isSame(endOfMonth, "day"); day = day.add(1, "day")){
            days.push(day);
        }
        return days;
    }, [
        currentMonth
    ]);
    var isInRange = (0,react.useCallback)(function(date) {
        if (!startDate) return false;
        if (!endDate && dateOnRange && dateOnRange.isAfter(startDate)) {
            return date.isAfter(startDate) && date.isBefore(dateOnRange);
        }
        if (endDate) {
            return date.isBetween(startDate, endDate, null, "()");
        }
        return false;
    }, [
        startDate,
        endDate,
        dateOnRange
    ]);
    var getButtonDayStyle = (0,react.useCallback)(function(date) {
        var day = date.date();
        var isToday = date.isSame(today, "day");
        var isPastDay = date.isBefore(today);
        var isSelected = startDate && date.isSame(startDate, "day") || endDate && date.isSame(endDate, "day");
        var isRangeDay = isInRange(date);
        var isHovered = dateOnRange && date.isSame(dateOnRange, "day");
        var style = {
            variant: "ghost",
            bg: undefined,
            color: "blue.800",
            children: day
        };
        if (isSelected) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                variant: "solid",
                bg: "blue.500",
                color: "white"
            });
        } else if (isRangeDay) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                bg: "blue.100"
            });
        } else if (isHovered) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                _hover: {
                    bg: "blue.100"
                }
            });
        } else if (isPastDay) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                textDecoration: "line-through",
                color: "gray.400",
                isDisabled: true
            });
        } else if (isToday) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                border: "1px solid",
                borderColor: "blue.500",
                color: "blue.500"
            });
        }
        return style;
    }, [
        today,
        dateOnRange,
        startDate,
        endDate,
        isInRange
    ]);
    var buttonStyles = (0,react.useMemo)(function() {
        var styles = new Map();
        getMonthDays.forEach(function(date) {
            var key = date.format("YYYY-MM-DD");
            styles.set(key, getButtonDayStyle(date));
        });
        return styles;
    }, [
        getMonthDays,
        getButtonDayStyle
    ]);
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Box */.xu, {
        minWidth: "24rem",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Popover */.J2, {
            placement: "bottom-start",
            isOpen: isOpen,
            onOpen: onOpen,
            onClose: onClose,
            autoFocus: false,
            returnFocusOnClose: false,
            matchWidth: true,
            isLazy: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* PopoverTrigger */.xo, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* InputGroup */.BZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Input */.II, {
                                value: (ref6 = getInputDisplayValue()) !== null && ref6 !== void 0 ? ref6 : "",
                                placeholder: formatMessage({
                                    id: date_range_picker_intl/* dateRangePickerIntlIds.selectPeriodOrDateInput.placeholder */.oN.selectPeriodOrDateInput.placeholder
                                }),
                                cursor: "pointer",
                                isReadOnly: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* InputRightElement */.xH, {
                                pointerEvents: "none",
                                color: isOpen ? "blue.500" : "gray.800",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md/* MdOutlineCalendarToday */.nXc, {
                                    color: "inherit"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* PopoverContent */.yk, {
                    ref: ref,
                    width: "100%",
                    padding: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* PopoverArrow */.QH, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                            flexDirection: "column",
                            alignItems: "stretch",
                            gap: 6,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* IconButton */.hU, {
                                            "aria-label": formatMessage({
                                                id: date_range_picker_intl/* dateRangePickerIntlIds.previousMonthAria.label */.oN.previousMonthAria.label
                                            }),
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io/* IoIosArrowBack */.u1R, {}),
                                            size: "sm",
                                            onClick: function() {
                                                return setCurrentMonth(currentMonth.subtract(1, "month"));
                                            },
                                            variant: "ghost",
                                            colorScheme: "blue"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                                            children: currentMonth.locale(window.navigator.language).format("MMMM, YYYY")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* IconButton */.hU, {
                                            "aria-label": formatMessage({
                                                id: date_range_picker_intl/* dateRangePickerIntlIds.nextMonthAria.label */.oN.nextMonthAria.label
                                            }),
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io/* IoIosArrowForward */.hjJ, {}),
                                            size: "sm",
                                            onClick: function() {
                                                return setCurrentMonth(currentMonth.add(1, "month"));
                                            },
                                            variant: "ghost",
                                            colorScheme: "blue"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Grid */.rj, {
                                    templateColumns: "repeat(7, 1fr)",
                                    alignItems: "center",
                                    justifyItems: "center",
                                    gap: 1,
                                    children: [
                                        (0,libs/* dayjs */.B)().locale(window.navigator.language).localeData().weekdaysShort().map(function(weekday) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                                                fontSize: "sm",
                                                color: "gray.600",
                                                children: weekday
                                            }, weekday);
                                        }),
                                        getMonthDays.map(function(date) {
                                            var key = date.format("YYYY-MM-DD");
                                            var ref;
                                            var style = (ref = buttonStyles.get(key)) !== null && ref !== void 0 ? ref : {};
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, (0,_object_spread/* default */.Z)({
                                                width: 10,
                                                height: 10,
                                                rounded: "full",
                                                onClick: function() {
                                                    return handleDateClick(date);
                                                },
                                                onMouseEnter: function() {
                                                    return setDateOnRange(date);
                                                }
                                            }, style), key);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                                            variant: "link",
                                            colorScheme: "blue",
                                            onClick: function() {
                                                return setCurrentMonth(today);
                                            },
                                            children: formatMessage({
                                                id: date_range_picker_intl/* dateRangePickerIntlIds.goBackToTodayButton.label */.oN.goBackToTodayButton.label
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                                                    variant: "outline",
                                                    onClick: startDate ? handleClearPeriod : onClose,
                                                    children: startDate ? formatMessage({
                                                        id: date_range_picker_intl/* dateRangePickerIntlIds.clearSelectedPeriodButton.label */.oN.clearSelectedPeriodButton.label
                                                    }) : formatMessage({
                                                        id: date_range_picker_intl/* dateRangePickerIntlIds.cancelButton.label */.oN.cancelButton.label
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                                                    colorScheme: "blue",
                                                    isDisabled: !startDate || !endDate,
                                                    onClick: handleRangePick,
                                                    children: formatMessage({
                                                        id: date_range_picker_intl/* dateRangePickerIntlIds.selectPeriodButton.label */.oN.selectPeriodButton.label
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./common/core-components/date-range-picker/index.ts


// EXTERNAL MODULE: ./common/core-components/delivery-search-input/intl/index.ts + 4 modules
var delivery_search_input_intl = __webpack_require__(5643);
;// CONCATENATED MODULE: ./common/core-components/delivery-search-input/delivery-search-input.tsx






function DeliverySearchInput(param) {
    var onSearch = param.onSearch, orderId = param.orderId, riderId = param.riderId;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var defaultSearchBy = !!riderId ? "riderId" : "orderId";
    var ref;
    var defaultValue = (ref = riderId !== null && riderId !== void 0 ? riderId : orderId) !== null && ref !== void 0 ? ref : "";
    var ref1 = (0,react.useState)(defaultSearchBy), searchBy = ref1[0], setSearchBy = ref1[1];
    var handleSubmit = function(event) {
        event.preventDefault();
        var elements = event.currentTarget.elements;
        onSearch(searchBy, elements.search.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Flex */.kC, {
        as: "form",
        gap: 2,
        onSubmit: handleSubmit,
        minW: "fit-content",
        justifyContent: "flex-end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* InputGroup */.BZ, {
            w: "auto",
            children: [
                orderId && riderId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* InputLeftAddon */.Ui, {
                    py: 0,
                    px: 1,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                        style: {
                            background: "transparent",
                            border: "none"
                        },
                        onChange: function(event) {
                            return setSearchBy(event.target.value);
                        },
                        value: searchBy,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "orderId",
                                children: formatMessage({
                                    id: delivery_search_input_intl/* deliverySearchInputIntlIds.type.orderId */.JF.type.orderId
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "riderId",
                                children: formatMessage({
                                    id: delivery_search_input_intl/* deliverySearchInputIntlIds.type.riderId */.JF.type.riderId
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* InputLeftAddon */.Ui, {
                    py: 0,
                    px: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                        as: "strong",
                        color: "gray.600",
                        children: formatMessage({
                            id: delivery_search_input_intl/* deliverySearchInputIntlIds.type.searchBy */.JF.type.searchBy
                        }, {
                            searchBy: defaultSearchBy
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Input */.II, {
                    "aria-label": formatMessage({
                        id: delivery_search_input_intl/* deliverySearchInputIntlIds.input.label */.JF.input.label
                    }),
                    borderRadius: 0,
                    defaultValue: defaultValue,
                    name: "search",
                    w: "100%",
                    type: "search",
                    placeholder: formatMessage({
                        id: delivery_search_input_intl/* deliverySearchInputIntlIds.input.placeholder */.JF.input.placeholder
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* InputRightAddon */.xW, {
                    p: 0,
                    border: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        type: "submit",
                        "aria-label": formatMessage({
                            id: delivery_search_input_intl/* deliverySearchInputIntlIds.submitButton.label */.JF.submitButton.label
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md/* MdOutlineSearch */.Zh8, {
                            size: 24
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./common/core-components/delivery-search-input/index.ts


// EXTERNAL MODULE: ./common/uaa/index.ts + 9 modules
var uaa = __webpack_require__(643);
// EXTERNAL MODULE: ./types/index.ts + 1 modules
var types = __webpack_require__(8910);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./common/core-components/hocs/with-route-access/with-route-access.tsx






function withRouteAccess(Component, param) {
    var accesses = param.accesses;
    return function RouteAccess(props) {
        var router = (0,next_router.useRouter)();
        var profile = (0,uaa/* useProfile */.Un)();
        (0,react.useEffect)(function() {
            if (profile) {
                var hasAccess = (profile === null || profile === void 0 ? void 0 : profile.accessType) === types/* UserAccessType.Admin */.nl.Admin || accesses.some(function(access) {
                    return profile.accessType.includes(access);
                });
                if (!hasAccess) {
                    router.replace("/404");
                }
            }
        }, [
            profile,
            router
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, props));
    };
}

;// CONCATENATED MODULE: ./common/core-components/hocs/index.ts


// EXTERNAL MODULE: ./common/core-components/hubs-multi-select/index.ts + 1 modules
var hubs_multi_select = __webpack_require__(6147);
;// CONCATENATED MODULE: ./common/core-components/labeled-strong-content/labeled-strong-content.tsx




function LabeledStrongContent(param) {
    var label = param.label, value = param.value;
    var handleValueType = function handleValueType() {
        if (!value) return "--";
        if ((0,utils/* isValidIso8601DateFormat */.HA)(value)) {
            return (0,utils/* formatDateBasedOnTimeZone */.n)(value, {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit",
                hour: "numeric",
                minute: "numeric",
                hour12: false
            });
        }
        return value;
    };
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
        flex: 1,
        direction: "column",
        gap: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                fontSize: 14,
                color: "gray.600",
                children: formatMessage({
                    id: label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                as: "strong",
                fontSize: "md",
                children: handleValueType()
            })
        ]
    });
}

;// CONCATENATED MODULE: ./common/core-components/labeled-strong-content/index.ts


// EXTERNAL MODULE: ./common/core-components/manual-or-automatic-rider-assignment/intl/index.ts + 4 modules
var manual_or_automatic_rider_assignment_intl = __webpack_require__(8553);
;// CONCATENATED MODULE: ./common/core-components/manual-or-automatic-rider-assignment/manual-or-automatic-rider-assignment.tsx







function ManualOrAutomaticRiderAssignment(param) {
    var mode = param.mode, rider = param.rider, externalDispatch = param.externalDispatch;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var props = (0,react.useMemo)(function() {
        if (rider && !rider.isExternal) {
            return {
                color: "blue.600",
                children: formatMessage({
                    id: manual_or_automatic_rider_assignment_intl/* manualOrAutomaticRiderAssignmentIntlIds.status.riderAssigned */.VP.status.riderAssigned
                }, {
                    rider_name: rider.fullName
                })
            };
        }
        if (rider && rider.isExternal) {
            return {
                children: formatMessage({
                    id: manual_or_automatic_rider_assignment_intl/* manualOrAutomaticRiderAssignmentIntlIds.status.riderAssigned */.VP.status.riderAssigned
                }, {
                    rider_name: rider.fullName
                })
            };
        }
        if ((externalDispatch === null || externalDispatch === void 0 ? void 0 : externalDispatch.riderName) && (externalDispatch === null || externalDispatch === void 0 ? void 0 : externalDispatch.status) !== types/* ExternalDispatchStatus.Canceled */.eZ.Canceled) {
            return {
                color: "blue.600",
                children: formatMessage({
                    id: manual_or_automatic_rider_assignment_intl/* manualOrAutomaticRiderAssignmentIntlIds.status.riderAssigned */.VP.status.riderAssigned
                }, {
                    rider_name: "Uber ".concat(externalDispatch.riderName)
                })
            };
        }
        return ({
            manual: {
                color: "red.500",
                children: formatMessage({
                    id: manual_or_automatic_rider_assignment_intl/* manualOrAutomaticRiderAssignmentIntlIds.status.noRiderAssigned */.VP.status.noRiderAssigned
                })
            },
            automatic: {
                color: "yellow.600",
                children: formatMessage({
                    id: manual_or_automatic_rider_assignment_intl/* manualOrAutomaticRiderAssignmentIntlIds.status.findingRider */.VP.status.findingRider
                })
            },
            external: {
                color: "red.500",
                children: formatMessage({
                    id: manual_or_automatic_rider_assignment_intl/* manualOrAutomaticRiderAssignmentIntlIds.status.noRiderAssigned */.VP.status.noRiderAssigned
                })
            }
        })[mode];
    }, [
        formatMessage,
        rider,
        mode,
        externalDispatch === null || externalDispatch === void 0 ? void 0 : externalDispatch.riderName,
        externalDispatch === null || externalDispatch === void 0 ? void 0 : externalDispatch.status, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !(rider === null || rider === void 0 ? void 0 : rider.isExternal) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                overflow: "hidden",
                textOverflow: "ellipsis",
                children: formatMessage({
                    id: manual_or_automatic_rider_assignment_intl/* manualOrAutomaticRiderAssignmentIntlIds.mode.manualOrAutomatic */.VP.mode.manualOrAutomatic
                }, {
                    trip_mode: mode
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, (0,_object_spread/* default */.Z)({
                fontWeight: 500,
                overflow: "hidden",
                textOverflow: "ellipsis"
            }, props))
        ]
    });
}

;// CONCATENATED MODULE: ./common/core-components/manual-or-automatic-rider-assignment/index.ts


// EXTERNAL MODULE: ./modules/deliveries/intl/index.ts + 4 modules
var deliveries_intl = __webpack_require__(7302);
;// CONCATENATED MODULE: ./common/core-components/modality-tag/modality-tag.tsx






function ModalityTag(param) {
    var _type = param.type, type = _type === void 0 ? "bicycle" : _type;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var props = (0,react.useMemo)(function() {
        return ({
            bicycle: {
                bg: "blue.100",
                children: formatMessage({
                    id: deliveries_intl/* deliveriesIntlIds.details.trip.suggestedModality.tag.bicycle.label */.nx.details.trip.suggestedModality.tag.bicycle.label
                })
            },
            motorcycle: {
                fontSize: "xs",
                bg: "blue.200",
                children: formatMessage({
                    id: deliveries_intl/* deliveriesIntlIds.details.trip.suggestedModality.tag.motorcycle.label */.nx.details.trip.suggestedModality.tag.motorcycle.label
                }, {
                    suggested_modality: type
                })
            }
        })[type];
    }, [
        formatMessage,
        type
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Tag */.Vp, (0,_object_spread/* default */.Z)({
        p: 1
    }, props));
}

;// CONCATENATED MODULE: ./common/core-components/modality-tag/index.ts


// EXTERNAL MODULE: ./common/core-components/modals/base-modal.tsx
var base_modal = __webpack_require__(756);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.mjs
var io5 = __webpack_require__(8318);
// EXTERNAL MODULE: ./common/core-components/modals/intl/modals.ids.ts
var modals_ids = __webpack_require__(4121);
;// CONCATENATED MODULE: ./common/core-components/modals/intl/index.ts


;// CONCATENATED MODULE: ./common/core-components/modals/on-action-modal/on-action-modal.tsx






function OnActionModal(param) {
    var type = param.type, onSubmit = param.onSubmit, onCancel = param.onCancel, onClose = param.onClose, trigger = param.trigger;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_modal/* ModalProvider */.DY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_modal/* ModalOpenButton */.Sq, {
                children: trigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_modal/* ModalContent */.hz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* ModalHeader */.xB, {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                                children: formatMessage({
                                    id: modals_ids/* modalsIntlIds.onActionModal.header.title */.J.onActionModal.header.title
                                }, {
                                    type: type
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_modal/* ModalCloseButton */.ol, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                                    variant: "ghost",
                                    color: "black",
                                    p: 0,
                                    onClick: onClose,
                                    _hover: {
                                        bg: "blackAlpha.100"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5/* IoCloseOutline */.IOM, {
                                        size: 24,
                                        title: formatMessage({
                                            id: modals_ids/* modalsIntlIds.onActionModal.header.closeModalButton.label */.J.onActionModal.header.closeModalButton.label
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* ModalBody */.fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                            children: formatMessage({
                                id: modals_ids/* modalsIntlIds.onActionModal.body.content */.J.onActionModal.body.content
                            }, {
                                type: type
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* ModalFooter */.mz, {
                        gap: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_modal/* ModalCloseButton */.ol, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                                    colorScheme: "gray",
                                    onClick: onCancel,
                                    children: formatMessage({
                                        id: modals_ids/* modalsIntlIds.onActionModal.footer.onCancelButton.label */.J.onActionModal.footer.onCancelButton.label
                                    }, {
                                        type: type
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_modal/* ModalCloseButton */.ol, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                                    type: "submit",
                                    onClick: onSubmit,
                                    children: formatMessage({
                                        id: modals_ids/* modalsIntlIds.onActionModal.footer.onSubmitButton.label */.J.onActionModal.footer.onSubmitButton.label
                                    }, {
                                        type: type
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./common/core-components/modals/on-action-modal/index.ts


;// CONCATENATED MODULE: ./common/core-components/modals/index.ts



// EXTERNAL MODULE: ./common/core-components/multi-select/index.ts + 8 modules
var multi_select = __webpack_require__(5358);
;// CONCATENATED MODULE: ./common/core-components/pagination/components/pagination-button/pagination-button.tsx


function PaginationButton(param) {
    var isDisabled = param.isDisabled, onPageChange = param.onPageChange, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
        className: "material-symbols-outlined",
        size: "sm",
        fontSize: "md",
        width: "4",
        color: "gray.600",
        bg: "transparent",
        _hover: {
            bg: "transparent"
        },
        _active: {
            bg: "transparent"
        },
        onClick: onPageChange,
        isDisabled: isDisabled,
        children: children
    });
}

;// CONCATENATED MODULE: ./common/core-components/pagination/components/pagination-button/index.ts


;// CONCATENATED MODULE: ./common/core-components/pagination/hooks/use-pagination.hook.ts
function usePagination(param) {
    var offset = param.offset, limit = param.limit, totalCount = param.totalCount;
    var firstItemPerPage = offset + 1;
    var lastItem = offset + limit;
    var lastItemPerPage = lastItem >= totalCount ? totalCount : lastItem;
    var currentPage = Math.ceil(firstItemPerPage / limit);
    var lastPage = Math.ceil(totalCount / limit);
    return {
        currentPage: currentPage,
        firstItemPerPage: firstItemPerPage,
        lastItemPerPage: lastItemPerPage,
        lastPage: lastPage,
        totalCount: totalCount
    };
}

// EXTERNAL MODULE: ./common/core-components/pagination/intl/index.ts + 4 modules
var pagination_intl = __webpack_require__(5198);
// EXTERNAL MODULE: ./common/ui-components/flex/flex.tsx + 1 modules
var flex = __webpack_require__(9521);
;// CONCATENATED MODULE: ./common/core-components/pagination/components/input-page/input-page.styles.ts

function input_page_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n"
    ]);
    input_page_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledLabel = (0,ui_components/* styled */.zo)("label")(input_page_styles_templateObject());

;// CONCATENATED MODULE: ./common/core-components/pagination/components/input-page/input-page.tsx





/* harmony default export */ var input_page = (/*#__PURE__*/(0,react.forwardRef)(function InputPage(param, ref) {
    var currentPage = param.currentPage, max = param.max;
    var _$ref = (0,react.useState)(currentPage), state = _$ref[0], setState = _$ref[1];
    var handleChange = function(event) {
        setState(+event.currentTarget.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* default */.Z, {
        position: "relative",
        mx: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* default */.Z, {
            color: "transparent",
            px: 3,
            minW: 8,
            height: 10,
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
                    htmlFor: "pagination-input-page",
                    children: "Page"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Input */.II, {
                    "aria-label": "Page",
                    px: 1,
                    position: "absolute",
                    width: "100%",
                    left: 0,
                    right: 0,
                    ref: ref,
                    name: "page",
                    id: "pagination-input-page",
                    defaultValue: state,
                    type: "number",
                    min: 1,
                    max: max,
                    bg: "gray.100",
                    color: "gray.600",
                    borderRadius: "md",
                    textAlign: "center",
                    onChange: handleChange,
                    isRequired: true
                }),
                state
            ]
        })
    });
}));

;// CONCATENATED MODULE: ./common/core-components/pagination/components/input-page/index.ts


;// CONCATENATED MODULE: ./common/core-components/pagination/utils/create-tag-wrapper/create-tag-wrapper.tsx



function createTagWrapper(props) {
    return function createTagWrapperNested(_chunks) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(input_page, (0,_object_spread/* default */.Z)({}, props));
    };
}

;// CONCATENATED MODULE: ./common/core-components/pagination/utils/create-tag-wrapper/index.ts


;// CONCATENATED MODULE: ./common/core-components/pagination/pagination.tsx









function Pagination(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _limit = param.limit, limit = _limit === void 0 ? 0 : _limit, offset = param.offset, _totalCount = param.totalCount, totalCount = _totalCount === void 0 ? 0 : _totalCount, onPageChange = param.onPageChange;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var ref = usePagination({
        offset: offset,
        limit: limit,
        totalCount: totalCount
    }), currentPage = ref.currentPage, lastPage = ref.lastPage, firstItemPerPage = ref.firstItemPerPage, lastItemPerPage = ref.lastItemPerPage;
    var createTag = (0,react.useCallback)(createTagWrapper, [
        currentPage,
        lastPage
    ]);
    var inputRef = react.useRef(null);
    var handleSubmit = function(event) {
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var page = +elements.page.value;
        var value = (page - 1 < 0 ? currentPage : page - 1) * limit;
        onPageChange(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
        as: "form",
        mt: "4",
        justify: "flex-end",
        align: "center",
        onSubmit: handleSubmit,
        display: "flex",
        title: "pagination form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                as: "span",
                fontSize: "sm",
                color: "gray.600",
                textAlign: "right",
                children: isLoading ? formatMessage({
                    id: pagination_intl/* paginationIntlIds.pagination.loading */.ah.pagination.loading
                }) : formatMessage({
                    id: pagination_intl/* paginationIntlIds.pagination.items */.ah.pagination.items
                }, {
                    first_item_per_page: firstItemPerPage,
                    last_item_per_page: lastItemPerPage,
                    total_count: totalCount
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                flexShrink: 0,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Flex */.kC, {
                        alignItems: "center",
                        mx: 7,
                        fontSize: "sm",
                        color: "gray.600",
                        flexGrow: 2,
                        flexShrink: 0,
                        "data-testid": "pages_informations",
                        align: "center",
                        children: formatMessage({
                            id: pagination_intl/* paginationIntlIds.pagination.pages */.ah.pagination.pages
                        }, {
                            current_page: isLoading ? 1 : currentPage,
                            last_page: isLoading ? null : lastPage,
                            span: utils/* createSpanTagWrapper */.XZ,
                            tag: createTag({
                                ref: inputRef,
                                currentPage: currentPage,
                                max: lastPage
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                        onPageChange: function() {
                            if (inputRef.current) {
                                inputRef.current.value = String(currentPage - 1);
                                onPageChange(offset - limit);
                            }
                        },
                        isDisabled: isLoading || currentPage === 1,
                        children: "arrow_back_ios"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                        onPageChange: function() {
                            if (inputRef.current) {
                                inputRef.current.value = String(currentPage + 1);
                                onPageChange(offset + limit);
                            }
                        },
                        isDisabled: isLoading || currentPage === lastPage,
                        children: "arrow_forward_ios"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./common/core-components/pagination/index.ts



;// CONCATENATED MODULE: ./common/core-components/spinner-loading/spinner-loading.tsx


function SpinnerLoading(param) {
    var _position = param.position, position = _position === void 0 ? "unset" : _position;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Flex */.kC, {
        style: {
            position: position
        },
        w: "100%",
        h: "100%",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Spinner */.$j, {
            thickness: "4px",
            speed: "0.65s",
            color: "blue.500",
            size: "xl"
        })
    });
}

;// CONCATENATED MODULE: ./common/core-components/spinner-loading/index.ts


// EXTERNAL MODULE: ./common/core-components/status-tag/intl/status-tag.ids.ts
var status_tag_ids = __webpack_require__(9747);
;// CONCATENATED MODULE: ./common/core-components/status-tag/intl/index.ts


;// CONCATENATED MODULE: ./common/core-components/status-tag/status-tag.tsx






function StatusTag(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? true : _isActive;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var props = (0,react.useMemo)(function() {
        if (isActive) {
            return {
                bg: "green.200",
                color: "gray.800",
                children: formatMessage({
                    id: status_tag_ids/* statusTagIntlIds.active */.K.active
                })
            };
        }
        return {
            bg: "gray.300",
            color: "gray.800",
            children: formatMessage({
                id: status_tag_ids/* statusTagIntlIds.inactive */.K.inactive
            })
        };
    }, [
        isActive,
        formatMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Tag */.Vp, (0,_object_spread/* default */.Z)({
        p: 1
    }, props));
}

;// CONCATENATED MODULE: ./common/core-components/status-tag/index.ts


;// CONCATENATED MODULE: ./common/core-components/strong-labeled-content-with-icon/strong-labeled-content-with-icon.tsx



function StrongLabeledContentWithIcon(param) {
    var icon = param.icon, label = param.label, _showDivider = param.showDivider, showDivider = _showDivider === void 0 ? false : _showDivider, children = param.children;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
        direction: "column",
        gap: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                align: "center",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Box */.xu, {
                        color: "blue.600",
                        fontSize: 14,
                        children: icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                        as: "strong",
                        fontSize: 14,
                        whiteSpace: "nowrap",
                        children: formatMessage({
                            id: label
                        })
                    }),
                    showDivider ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Divider */.iz, {}) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Grid */.rj, {
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: 4,
                children: children
            })
        ]
    });
}

;// CONCATENATED MODULE: ./common/core-components/strong-labeled-content-with-icon/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./common/core-components/table-header/table-header.tsx





function TableHeader(param) {
    var headers = param.headers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: headers.map(function(_param, index) /*#__PURE__*/ {
            var label = _param.label, props = (0,_object_without_properties/* default */.Z)(_param, [
                "label"
            ]);
            return (0,jsx_runtime.jsx)(ui_components/* TableCellHead */.fq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: "gray.600",
                fontSize: "xs",
                p: 2
            }, props), {
                children: label
            }), index);
        })
    });
}

;// CONCATENATED MODULE: ./common/core-components/table-header/index.ts


;// CONCATENATED MODULE: ./common/core-components/table/table.styles.ts
var tableContentCss = {
    tableLayout: "fixed"
};

;// CONCATENATED MODULE: ./common/core-components/table/table.tsx







function Table(_param) {
    var headers = _param.headers, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "headers",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* TableContainer */.xJ, {
        flex: 1,
        overflowX: "auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Table */.iA, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            css: tableContentCss,
            variant: "striped"
        }, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* TableHead */.ss, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* TableRow */.SC, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeader, {
                            headers: headers
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* TableBody */.RM, {
                    children: children
                })
            ]
        }))
    });
}

;// CONCATENATED MODULE: ./common/core-components/table/index.ts


;// CONCATENATED MODULE: ./common/core-components/title-page/title-page.tsx


function TitlePage(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
        as: "h1",
        fontSize: "3xl",
        fontWeight: "600",
        children: children
    });
}

;// CONCATENATED MODULE: ./common/core-components/title-page/index.ts


;// CONCATENATED MODULE: ./common/core-components/toasts/use-base-toast.tsx

function useBaseToast(param) {
    var title = param.title, description = param.description, status = param.status;
    return (0,ui_components/* useToast */.pm)({
        title: title,
        description: description,
        status: status,
        isClosable: true,
        variant: "subtle",
        position: "top-right"
    });
}

;// CONCATENATED MODULE: ./common/core-components/toasts/use-on-error-toast/use-on-error-toast.tsx

function useOnErrorToast(param) {
    var title = param.title, description = param.description;
    return useBaseToast({
        title: title,
        description: description,
        status: "error"
    });
}

;// CONCATENATED MODULE: ./common/core-components/toasts/use-on-error-toast/index.ts


// EXTERNAL MODULE: ./common/core-components/toasts/intl/index.ts + 4 modules
var toasts_intl = __webpack_require__(9098);
;// CONCATENATED MODULE: ./common/core-components/toasts/use-on-loading-toast/use-on-loading-toast.tsx



function useOnLoadingToast() {
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    return useBaseToast({
        title: formatMessage({
            id: toasts_intl/* toastsIntlIds.onLoadingToast.title */.ZD.onLoadingToast.title
        }),
        description: formatMessage({
            id: toasts_intl/* toastsIntlIds.onLoadingToast.description */.ZD.onLoadingToast.description
        }),
        status: "info"
    });
}

;// CONCATENATED MODULE: ./common/core-components/toasts/use-on-loading-toast/index.ts


;// CONCATENATED MODULE: ./common/core-components/toasts/use-on-success-toast/use-on-success-toast.tsx

function useOnSuccessToast(param) {
    var title = param.title, description = param.description;
    return useBaseToast({
        title: title,
        description: description,
        status: "success"
    });
}

;// CONCATENATED MODULE: ./common/core-components/toasts/use-on-success-toast/index.ts


;// CONCATENATED MODULE: ./common/core-components/toasts/use-on-warning-toast/use-on-warning-toast.tsx

function useOnWarningToast(param) {
    var title = param.title, description = param.description;
    return useBaseToast({
        title: title,
        description: description,
        status: "warning"
    });
}

;// CONCATENATED MODULE: ./common/core-components/toasts/use-on-warning-toast/index.ts


;// CONCATENATED MODULE: ./common/core-components/toasts/index.ts





// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./modules/trips/contexts/index.ts + 4 modules
var contexts = __webpack_require__(7646);
// EXTERNAL MODULE: ./common/core-components/trip-infos/intl/trip-infos.ids.ts
var trip_infos_ids = __webpack_require__(1986);
;// CONCATENATED MODULE: ./common/core-components/trip-infos/change-or-assign-trip-rider-modal/change-or-assign-trip-rider-modal.tsx









function ChangeOrAssignTripRiderModal(param) {
    var trigger = param.trigger, title = param.title, hubId = param.hubId, tripId = param.tripId, journeys = param.journeys, isGetJourneysLoading = param.isGetJourneysLoading, getJourneys = param.getJourneys, onCancel = param.onCancel, onSubmit = param.onSubmit;
    var handleSelectedRiderId = function handleSelectedRiderId(selected) {
        setSelectedRiderId(selected.value);
    };
    var handleUpdateSelectedRider = function handleUpdateSelectedRider() {
        var journey = journeys === null || journeys === void 0 ? void 0 : journeys.find(function(param) {
            var rider = param.rider;
            return selectedRiderId === (rider === null || rider === void 0 ? void 0 : rider.id);
        });
        if (journey === null || journey === void 0 ? void 0 : journey.rider) {
            setRider({
                id: journey.rider.id,
                fullName: journey.rider.fullName,
                isExternal: journey.rider.isExternal
            });
            return;
        }
        setRider(null);
    };
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var isOpen = (0,base_modal/* useModal */.dd)().isOpen;
    var ref = (0,contexts/* useCreateOrEditTrip */.Xv)(), selectedRiderId = ref.data.selectedRiderId, _actions = ref.actions, setSelectedRiderId = _actions.setSelectedRiderId, setRider = _actions.setRider;
    (0,react.useEffect)(function getJourneysForTrip() {
        if (isOpen && hubId) {
            getJourneys(hubId, tripId);
        }
    }, [
        isOpen,
        hubId,
        tripId
    ]);
    var ref1;
    var journeysToSelectMapper = (ref1 = journeys === null || journeys === void 0 ? void 0 : journeys.map(function(journey) {
        return {
            value: journey.rider.id,
            label: journey.rider.fullName
        };
    })) !== null && ref1 !== void 0 ? ref1 : [];
    var noRiderOption = {
        value: null,
        label: formatMessage({
            id: trip_infos_ids/* tripInfosIntlIds.changeOrAssignTripRiderModal.selectRider.option.noRider */.K.changeOrAssignTripRiderModal.selectRider.option.noRider
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_modal/* ModalOpenButton */.Sq, {
                children: trigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_modal/* ModalContent */.hz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* ModalHeader */.xB, {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_modal/* ModalCloseButton */.ol, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                                    variant: "ghost",
                                    color: "black",
                                    p: 0,
                                    _hover: {
                                        bg: "blackAlpha.100"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5/* IoCloseOutline */.IOM, {
                                        size: 24,
                                        title: formatMessage({
                                            id: trip_infos_ids/* tripInfosIntlIds.changeOrAssignTripRiderModal.button.cancel.label */.K.changeOrAssignTripRiderModal.button.cancel.label
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* ModalBody */.fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* MultiSelect */.NU, {
                            placeholder: formatMessage({
                                id: trip_infos_ids/* tripInfosIntlIds.changeOrAssignTripRiderModal.selectRider.placeholder */.K.changeOrAssignTripRiderModal.selectRider.placeholder
                            }),
                            onChange: handleSelectedRiderId,
                            options: [
                                noRiderOption
                            ].concat((0,_to_consumable_array/* default */.Z)(journeysToSelectMapper)),
                            useBasicStyles: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* ModalFooter */.mz, {
                        gap: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_modal/* ModalCloseButton */.ol, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                                    colorScheme: "gray",
                                    gap: 3,
                                    onClick: onCancel,
                                    children: formatMessage({
                                        id: trip_infos_ids/* tripInfosIntlIds.changeOrAssignTripRiderModal.button.cancel.label */.K.changeOrAssignTripRiderModal.button.cancel.label
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_modal/* ModalCloseButton */.ol, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                                    bg: "blue.500",
                                    isLoading: isGetJourneysLoading,
                                    onClick: onSubmit !== null && onSubmit !== void 0 ? onSubmit : handleUpdateSelectedRider,
                                    children: !tripId ? formatMessage({
                                        id: trip_infos_ids/* tripInfosIntlIds.changeOrAssignTripRiderModal.button.assign.label */.K.changeOrAssignTripRiderModal.button.assign.label
                                    }) : formatMessage({
                                        id: trip_infos_ids/* tripInfosIntlIds.changeOrAssignTripRiderModal.button.sendOffer.label */.K.changeOrAssignTripRiderModal.button.sendOffer.label
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./common/core-components/trip-infos/change-or-assign-trip-rider-modal/index.ts


;// CONCATENATED MODULE: ./common/core-components/trip-infos/trip-action-button/trip-action-button.tsx




function TripActionButton(param) {
    var isDisabled = param.isDisabled, variant = param.variant, type = param.type, onClick = param.onClick;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
        isDisabled: isDisabled,
        variant: variant,
        onClick: onClick,
        children: formatMessage({
            id: trip_infos_ids/* tripInfosIntlIds.tripActionButton.label */.K.tripActionButton.label
        }, {
            type: type
        })
    });
}

;// CONCATENATED MODULE: ./common/core-components/trip-infos/trip-action-button/index.ts


// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
;// CONCATENATED MODULE: ./common/core-components/trip-infos/trip-rider-assign/trip-rider-assign.tsx







function TripRiderAssign(param) {
    var trip = param.trip, rider = param.rider;
    var formatMessage = (0,useIntl/* default */.Z)().formatMessage;
    var tripModeStatus = (0,react.useMemo)(function() {
        if ((trip === null || trip === void 0 ? void 0 : trip.rider) || rider) {
            return {
                color: "gray.800",
                children: formatMessage({
                    id: trip_infos_ids/* tripInfosIntlIds.tripDetails.assignmentMode.status.assigned */.K.tripDetails.assignmentMode.status.assigned
                })
            };
        }
        var ref;
        return ({
            manual: {
                color: "red.500",
                children: formatMessage({
                    id: trip_infos_ids/* tripInfosIntlIds.tripDetails.assignmentMode.status.noRiderAssigned */.K.tripDetails.assignmentMode.status.noRiderAssigned
                })
            },
            automatic: {
                color: "yellow.700",
                children: formatMessage({
                    id: trip_infos_ids/* tripInfosIntlIds.tripDetails.assignmentMode.status.findingRider */.K.tripDetails.assignmentMode.status.findingRider
                })
            },
            external: {
                color: "red.500",
                children: formatMessage({
                    id: trip_infos_ids/* tripInfosIntlIds.tripDetails.assignmentMode.status.noRiderAssigned */.K.tripDetails.assignmentMode.status.noRiderAssigned
                })
            }
        })[(ref = trip === null || trip === void 0 ? void 0 : trip.mode) !== null && ref !== void 0 ? ref : types/* TripMode.Manual */.OE.Manual];
    }, [
        formatMessage,
        trip === null || trip === void 0 ? void 0 : trip.mode,
        trip === null || trip === void 0 ? void 0 : trip.rider,
        rider
    ]);
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                fontWeight: "600",
                children: formatMessage({
                    id: trip_infos_ids/* tripInfosIntlIds.tripDetails.id.label */.K.tripDetails.id.label
                }, {
                    tripId: (ref = trip === null || trip === void 0 ? void 0 : trip.id) !== null && ref !== void 0 ? ref : "-"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                        as: "span",
                        children: formatMessage({
                            id: trip_infos_ids/* tripInfosIntlIds.tripDetails.assignmentMode.label */.K.tripDetails.assignmentMode.label
                        }, {
                            tripMode: (ref1 = trip === null || trip === void 0 ? void 0 : trip.mode) !== null && ref1 !== void 0 ? ref1 : types/* TripMode.Manual */.OE.Manual
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, (0,_object_spread/* default */.Z)({}, tripModeStatus))
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./common/core-components/trip-infos/trip-rider-assign/index.ts


;// CONCATENATED MODULE: ./common/core-components/trip-infos/trip-rider-infos/trip-rider-infos.tsx





function TripRiderInfos(param) {
    var rider = param.rider, hub = param.hub;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
        gap: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Avatar */.qE, {
                title: formatMessage({
                    id: trip_infos_ids/* tripInfosIntlIds.tripRiderInfos.avatar.title */.K.tripRiderInfos.avatar.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                direction: "column",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                                fontSize: "md",
                                fontWeight: "600",
                                children: rider.fullName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Text */.xv, {
                                children: [
                                    "ID: ",
                                    rider === null || rider === void 0 ? void 0 : rider.id
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                                color: "gray.600",
                                fontSize: "sm",
                                children: formatMessage({
                                    id: trip_infos_ids/* tripInfosIntlIds.tripRiderInfos.hub */.K.tripRiderInfos.hub
                                }, {
                                    hubAlias: hub === null || hub === void 0 ? void 0 : hub.alias,
                                    highlight: function(chunks) {
                                        return (0,utils/* createHighlightTextWrapper */.t$)(chunks, "gray.600");
                                    }
                                })
                            }),
                            (rider === null || rider === void 0 ? void 0 : rider.isExternal) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                                color: "gray.600",
                                fontSize: "sm",
                                children: formatMessage({
                                    id: trip_infos_ids/* tripInfosIntlIds.tripRiderInfos.modal */.K.tripRiderInfos.modal
                                }, {
                                    highlight: function(chunks) {
                                        return (0,utils/* createHighlightTextWrapper */.t$)(chunks, "gray.600");
                                    }
                                })
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./common/core-components/trip-infos/trip-rider-infos/index.ts


;// CONCATENATED MODULE: ./common/core-components/trip-infos/index.ts





// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./common/core-components/upload-file/intl/index.ts + 4 modules
var upload_file_intl = __webpack_require__(8122);
;// CONCATENATED MODULE: ./common/core-components/upload-file/components/upload-file-input/upload-file-input.tsx






var UploadFileInput = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var acceptedTypes = param.acceptedTypes, handleInputClick = param.handleInputClick, handleFileUpload = param.handleFileUpload;
    var handleDragFileOver = function handleDragFileOver(event) {
        event.preventDefault();
        setIsDragging(true);
    };
    var handleDropFile = function handleDropFile(event) {
        event.preventDefault();
        setIsDragging(false);
        if (event.dataTransfer.files.length > 0) {
            var fileInput = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
            if (fileInput) {
                var dataTransfer = new DataTransfer();
                dataTransfer.items.add(event.dataTransfer.files[0]);
                fileInput.files = dataTransfer.files;
                fileInput.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            }
        }
    };
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var _$ref = (0,react.useState)(false), isDragging = _$ref[0], setIsDragging = _$ref[1];
    var inputRef = ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: "1px dashed",
        borderColor: isDragging ? "blue.500" : "gray.300",
        borderRadius: 8,
        color: "blue.500",
        bg: "gray.50",
        cursor: "pointer",
        padding: 5,
        gap: 2,
        onClick: handleInputClick,
        onDragOver: handleDragFileOver,
        onDragLeave: function() {
            return setIsDragging(false);
        },
        onDrop: handleDropFile,
        _hover: {
            borderColor: "blue.500"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(io5/* IoCloudUploadOutline */.v8B, {
                size: 32
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                fontWeight: "bold",
                color: "blue.500",
                children: formatMessage({
                    id: upload_file_intl/* uploadFileIntlIds.label */.u0.label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                fontSize: "sm",
                color: "gray.500",
                children: formatMessage({
                    id: upload_file_intl/* uploadFileIntlIds.maxSize */.u0.maxSize
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Input */.II, {
                ref: inputRef,
                "aria-label": formatMessage({
                    id: upload_file_intl/* uploadFileIntlIds.label */.u0.label
                }),
                type: "file",
                onChange: handleFileUpload,
                accept: acceptedTypes,
                style: {
                    opacity: 0,
                    position: "absolute",
                    pointerEvents: "none"
                }
            })
        ]
    });
});
UploadFileInput.displayName = "UploadFileInput";

;// CONCATENATED MODULE: ./common/core-components/upload-file/components/upload-file-input/index.ts


// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.mjs
var bi = __webpack_require__(1121);
;// CONCATENATED MODULE: ./common/core-components/upload-file/components/uploaded-file-card/uploaded-file-card.tsx








function UploadedFileCard(param) {
    var _type = param.type, type = _type === void 0 ? "processing" : _type, uploadedFile = param.uploadedFile, handleRemoveFile = param.handleRemoveFile;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var props = (0,react.useMemo)(function() {
        return ({
            processing: {
                color: "blue.500",
                bg: "blue.100",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Spinner */.$j, {
                    thickness: "2px",
                    speed: "0.7s",
                    color: "blue.500"
                }),
                label: formatMessage({
                    id: upload_file_intl/* uploadFileIntlIds.onUpload.processing.label */.u0.onUpload.processing.label
                })
            },
            success: {
                color: "green.500",
                bg: "green.100",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5/* IoCheckmarkCircleOutline */.GcF, {
                    size: 24
                }),
                label: formatMessage({
                    id: upload_file_intl/* uploadFileIntlIds.onUpload.success.label */.u0.onUpload.success.label
                })
            },
            exceededSize: {
                color: "red.500",
                bg: "red.100",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bi/* BiErrorCircle */.Cw1, {
                    size: 24
                }),
                label: formatMessage({
                    id: upload_file_intl/* uploadFileIntlIds.onUpload.exceededSize.label */.u0.onUpload.exceededSize.label
                }),
                errorMessage: formatMessage({
                    id: upload_file_intl/* uploadFileIntlIds.onUpload.exceededSize.error.label */.u0.onUpload.exceededSize.error.label
                })
            },
            failed: {
                color: "red.500",
                bg: "red.100",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bi/* BiErrorCircle */.Cw1, {
                    size: 24
                }),
                label: formatMessage({
                    id: upload_file_intl/* uploadFileIntlIds.onUpload.failed.label */.u0.onUpload.failed.label
                }),
                errorMessage: formatMessage({
                    id: upload_file_intl/* uploadFileIntlIds.onUpload.failed.error.label */.u0.onUpload.failed.error.label
                })
            }
        })[type];
    }, [
        type,
        formatMessage
    ]);
    var hasErrorMessage = type !== "processing" && type !== "success";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
        flexDirection: "column",
        gap: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                alignItems: "center",
                borderWidth: 1,
                borderColor: "gray.300",
                borderRadius: 8,
                padding: 2,
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Circle */.Cd, {
                        size: 10,
                        color: props.color,
                        bg: props.bg,
                        children: props.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                        flex: 1,
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                                fontWeight: "bold",
                                color: props.color,
                                children: props.label
                            }),
                            uploadedFile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                                        fontSize: "sm",
                                        color: "gray.500",
                                        children: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Text */.xv, {
                                        fontSize: "xs",
                                        color: "gray.500",
                                        children: [
                                            (Number(uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.size) / 1024).toFixed(0),
                                            "KB"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                        onClick: handleRemoveFile,
                        variant: "ghost",
                        size: "sm",
                        color: "gray.800",
                        _hover: {
                            backgroundColor: "gray.100"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md/* MdOutlineDelete */.$vK, {
                            title: formatMessage({
                                id: upload_file_intl/* uploadFileIntlIds.onUpload.removeFile.label */.u0.onUpload.removeFile.label
                            }),
                            size: 20
                        })
                    })
                ]
            }),
            hasErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                alignItems: "center",
                color: props.color,
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bi/* BiErrorCircle */.Cw1, {
                        size: 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                        fontSize: "sm",
                        color: "inherit",
                        children: props.errorMessage
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./common/core-components/upload-file/components/uploaded-file-card/index.ts


;// CONCATENATED MODULE: ./common/core-components/upload-file/components/index.ts



// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./common/bff/index.ts + 34 modules
var bff = __webpack_require__(7470);
// EXTERNAL MODULE: ./common/observability/index.ts + 145 modules
var observability = __webpack_require__(6137);
;// CONCATENATED MODULE: ./use-cases/delete-file-from-cloud/delete-file-from-cloud.mutation.ts

function delete_file_from_cloud_mutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation Global_UseCase_DeleteFileFromCloud($scope: String!) {\n    deleteFileFromCloud(scope: $scope)\n  }\n"
    ]);
    delete_file_from_cloud_mutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var DELETE_FILE_FROM_CLOUD = (0,bff/* gql */.Ps)(delete_file_from_cloud_mutation_templateObject());

;// CONCATENATED MODULE: ./use-cases/delete-file-from-cloud/use-delete-file-from-cloud.ts






function useDeleteFileFromCloud() {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,bff/* useMutation */.Db)(DELETE_FILE_FROM_CLOUD, {
        onCompleted: function(content) {
            observability/* hermesLogger.info */.t.info("[DeleteFileFromCloud] File deleted successfully", content);
        },
        onError: function(error) {
            observability/* hermesLogger.error */.t.error("[DeleteFileFromCloud] Error when trying to delete file from cloud", {
                timestamp: new Date(),
                error: {
                    stack: error.stack,
                    message: error.message,
                    kind: error.name
                }
            });
        }
    }), 2), deleteFileFromCloud = ref1[0], ref2 = ref1[1], data = ref2.data, loading = ref2.loading, error = ref2.error;
    function handleDeleteFileFromCloud(scope) {
        return _handleDeleteFileFromCloud.apply(this, arguments);
    }
    function _handleDeleteFileFromCloud() {
        _handleDeleteFileFromCloud = (0,_async_to_generator/* default */.Z)(function(scope) {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deleteFileFromCloud({
                                variables: {
                                    scope: scope
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.errors) {
                            throw error;
                        }
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return _handleDeleteFileFromCloud.apply(this, arguments);
    }
    return {
        actions: {
            handleDeleteFileFromCloud: handleDeleteFileFromCloud
        },
        data: data === null || data === void 0 ? void 0 : data.deleteFileFromCloud,
        loading: loading,
        error: (ref = error === null || error === void 0 ? void 0 : error.graphQLErrors[0]) === null || ref === void 0 ? void 0 : ref.extensions
    };
}

;// CONCATENATED MODULE: ./use-cases/delete-file-from-cloud/index.ts


;// CONCATENATED MODULE: ./use-cases/get-file-from-cloud/get-file-from-cloud.query.ts

function get_file_from_cloud_query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Global_UseCase_GetFileFromCloud($scope: String!) {\n    fileFromCloud(scope: $scope) {\n      name\n      size\n    }\n  }\n"
    ]);
    get_file_from_cloud_query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var GET_FILE_FROM_CLOUD = (0,bff/* gql */.Ps)(get_file_from_cloud_query_templateObject());

;// CONCATENATED MODULE: ./use-cases/get-file-from-cloud/get-file-from-cloud.subscription.ts

function get_file_from_cloud_subscription_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  subscription Global_UseCase_GetFileFromCloud($scope: String!) {\n    fileFromCloud(scope: $scope) {\n      name\n      size\n    }\n  }\n"
    ]);
    get_file_from_cloud_subscription_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var GET_FILE_FROM_CLOUD_SUBSCRIPTION = (0,bff/* gql */.Ps)(get_file_from_cloud_subscription_templateObject());

;// CONCATENATED MODULE: ./use-cases/get-file-from-cloud/use-get-file-from-cloud.ts







function useGetFileFromCloud(param) {
    var scope = param.scope;
    var ref;
    var ref1 = (0,bff/* useQuery */.aM)(GET_FILE_FROM_CLOUD, {
        variables: {
            scope: scope
        },
        fetchPolicy: "network-only",
        onCompleted: function(content) {
            observability/* hermesLogger.info */.t.info("[GetFileFromCloud] File retrieved successfully", content);
        },
        onError: function(error) {
            observability/* hermesLogger.error */.t.error("[GetFileFromCloud] Error when trying to retrieve file from cloud", {
                timestamp: new Date(),
                error: {
                    stack: error.stack,
                    message: error.message,
                    kind: error.name
                }
            });
        }
    }), data = ref1.data, loading = ref1.loading, error = ref1.error, subscribeToMore = ref1.subscribeToMore;
    (0,react.useEffect)(function() {
        var unsubscribe = subscribeToMore({
            document: GET_FILE_FROM_CLOUD_SUBSCRIPTION,
            variables: {
                scope: scope
            },
            updateQuery: function(prev, param) {
                var subscriptionData = param.subscriptionData;
                var ref;
                if (!subscriptionData.data) return prev;
                var updatedFileFromCloud = (ref = subscriptionData.data.fileFromCloud) === null || ref === void 0 ? void 0 : ref.name;
                if (!updatedFileFromCloud) {
                    return {
                        fileFromCloud: null
                    };
                }
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    fileFromCloud: (0,_object_spread/* default */.Z)({}, prev.fileFromCloud, subscriptionData.data.fileFromCloud)
                });
            }
        });
        return function() {
            return unsubscribe();
        };
    }, [
        subscribeToMore,
        scope
    ]);
    return {
        data: data === null || data === void 0 ? void 0 : data.fileFromCloud,
        loading: loading,
        error: (ref = error === null || error === void 0 ? void 0 : error.graphQLErrors[0]) === null || ref === void 0 ? void 0 : ref.extensions
    };
}

;// CONCATENATED MODULE: ./use-cases/get-file-from-cloud/index.ts


;// CONCATENATED MODULE: ./use-cases/upload-file-to-cloud/upload-file-to-cloud.mutation.ts

function upload_file_to_cloud_mutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation Global_UseCase_UploadFileToCloud(\n    $scope: String!\n    $contentType: String!\n    $fileBase64: String!\n    $fileName: String!\n    $fileSize: Int!\n  ) {\n    uploadFileToCloud(\n      scope: $scope\n      contentType: $contentType\n      fileBase64: $fileBase64\n      fileName: $fileName\n      size: $fileSize\n    ) {\n      scope\n    }\n  }\n"
    ]);
    upload_file_to_cloud_mutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var UPLOAD_FILE_TO_CLOUD = (0,bff/* gql */.Ps)(upload_file_to_cloud_mutation_templateObject());

;// CONCATENATED MODULE: ./use-cases/upload-file-to-cloud/use-upload-file-to-cloud.ts






function useUploadFileToCloud() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,bff/* useMutation */.Db)(UPLOAD_FILE_TO_CLOUD, {
        onCompleted: function(content) {
            observability/* hermesLogger.info */.t.info("[UploadFileToCloud] File uploaded successfully", content);
        },
        onError: function(error) {
            observability/* hermesLogger.error */.t.error("[UploadFileToCloud] Error when trying to upload file to cloud", {
                timestamp: new Date(),
                error: {
                    stack: error.stack,
                    message: error.message,
                    kind: error.name
                }
            });
        }
    }), 2), uploadFileToCloud = ref[0], ref1 = ref[1], data = ref1.data, loading = ref1.loading, error = ref1.error;
    function handleUploadFileToCloud(scope, contentType, fileBase64, fileName, fileSize) {
        return _handleUploadFileToCloud.apply(this, arguments);
    }
    function _handleUploadFileToCloud() {
        _handleUploadFileToCloud = (0,_async_to_generator/* default */.Z)(function(scope, contentType, fileBase64, fileName, fileSize) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    uploadFileToCloud({
                        variables: {
                            scope: scope,
                            contentType: contentType,
                            fileBase64: fileBase64,
                            fileName: fileName,
                            fileSize: fileSize
                        }
                    })
                ];
            });
        });
        return _handleUploadFileToCloud.apply(this, arguments);
    }
    return {
        actions: {
            handleUploadFileToCloud: handleUploadFileToCloud
        },
        data: data === null || data === void 0 ? void 0 : data.uploadFileToCloud,
        loading: loading,
        error: error
    };
}

;// CONCATENATED MODULE: ./use-cases/upload-file-to-cloud/index.ts


;// CONCATENATED MODULE: ./use-cases/index.ts




;// CONCATENATED MODULE: ./common/core-components/upload-file/use-upload-file.ts





function useUploadFile(param) {
    var scopeToUpload = param.scopeToUpload;
    var inputRef = (0,react.useRef)(null);
    var ref = useUploadFileState(), uploadedFile = ref.uploadedFile, uploadStatus = ref.uploadStatus, hasErrorOnUpload = ref.hasErrorOnUpload;
    var ref1 = useUploadFileActions(), setUploadedFile = ref1.setUploadedFile, uploadOnGoing = ref1.uploadOnGoing, uploadSuccess = ref1.uploadSuccess, uploadFailed = ref1.uploadFailed, removeFile = ref1.removeFile;
    var ref2 = useGetFileFromCloud({
        scope: scopeToUpload
    }), fileLoadedFromCloud = ref2.data, isGetFileFromCloudLoading = ref2.loading, errorOnGetFileFromCloud = ref2.error;
    var ref3 = useUploadFileToCloud(), uploadFileToCloud = ref3.data, isUploadFileToCloudLoading = ref3.loading, errorOnUploadFileToCloud = ref3.error, handleUploadFileToCloud = ref3.actions.handleUploadFileToCloud;
    var ref4 = useDeleteFileFromCloud(), handleDeleteFileFromCloud = ref4.actions.handleDeleteFileFromCloud;
    (0,react.useEffect)(function() {
        if (isGetFileFromCloudLoading) {
            return uploadOnGoing();
        }
    }, [
        isGetFileFromCloudLoading,
        uploadOnGoing
    ]);
    (0,react.useEffect)(function() {
        if (errorOnGetFileFromCloud) {
            return uploadFailed("failed");
        }
    }, [
        errorOnGetFileFromCloud,
        uploadFailed
    ]);
    (0,react.useEffect)(function() {
        if (fileLoadedFromCloud) {
            return uploadSuccess(fileLoadedFromCloud);
        }
    }, [
        fileLoadedFromCloud,
        uploadSuccess
    ]);
    (0,react.useEffect)(function() {
        if (uploadedFile && isUploadFileToCloudLoading) {
            return uploadOnGoing(uploadedFile);
        }
    }, [
        uploadedFile,
        isUploadFileToCloudLoading,
        uploadOnGoing
    ]);
    (0,react.useEffect)(function() {
        if (uploadedFile && errorOnUploadFileToCloud) {
            return uploadFailed("failed", uploadedFile);
        }
    }, [
        uploadedFile,
        errorOnUploadFileToCloud,
        uploadFailed
    ]);
    (0,react.useEffect)(function() {
        if (uploadedFile && uploadFileToCloud && hasErrorOnUpload !== "exceededSize") {
            return uploadSuccess(uploadedFile);
        }
    }, [
        uploadedFile,
        uploadFileToCloud,
        hasErrorOnUpload,
        uploadSuccess
    ]);
    (0,react.useEffect)(function() {
        if (!fileLoadedFromCloud && !isGetFileFromCloudLoading && !errorOnGetFileFromCloud) {
            removeFile();
        }
    }, [
        fileLoadedFromCloud,
        isGetFileFromCloudLoading,
        errorOnGetFileFromCloud,
        removeFile, 
    ]);
    var handleRemoveFile = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        handleDeleteFileFromCloud(scopeToUpload)
                    ];
                case 1:
                    _state.sent();
                    if (inputRef.current) {
                        inputRef.current.value = "";
                    }
                    removeFile();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        handleDeleteFileFromCloud,
        scopeToUpload,
        removeFile
    ]);
    return {
        data: {
            inputRef: inputRef,
            uploadedFile: uploadedFile,
            hasErrorOnUpload: hasErrorOnUpload,
            uploadStatus: uploadStatus,
            fileLoadedFromCloud: fileLoadedFromCloud,
            uploadFileToCloud: uploadFileToCloud
        },
        actions: {
            setUploadedFile: setUploadedFile,
            removeFile: handleRemoveFile,
            uploadFailed: uploadFailed,
            handleUploadFileToCloud: handleUploadFileToCloud
        }
    };
}

;// CONCATENATED MODULE: ./common/core-components/upload-file/upload-file.tsx






// 5 MB
var DEFAULT_MAX_FILE_SIZE = 5 * 1024 * 1024;
function UploadFile(param) {
    var _acceptedTypes = param.acceptedTypes, acceptedTypes = _acceptedTypes === void 0 ? ".csv" : _acceptedTypes, scopeToUpload = param.scopeToUpload;
    var ref = useUploadFile({
        scopeToUpload: scopeToUpload
    }), _data = ref.data, inputRef = _data.inputRef, uploadedFile = _data.uploadedFile, uploadStatus = _data.uploadStatus, hasErrorOnUpload = _data.hasErrorOnUpload, _actions = ref.actions, setUploadedFile = _actions.setUploadedFile, removeFile = _actions.removeFile, uploadFailed = _actions.uploadFailed, handleUploadFileToCloud = _actions.handleUploadFileToCloud;
    var handleInputClick = (0,react.useCallback)(function() {
        if (inputRef.current) {
            inputRef.current.click();
        }
    }, [
        inputRef
    ]);
    var handleFileUpload = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var ref, file, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        file = (ref = event.target.files) === null || ref === void 0 ? void 0 : ref[0];
                        if (!file) return [
                            2
                        ];
                        if (file.size > DEFAULT_MAX_FILE_SIZE) {
                            return [
                                2,
                                uploadFailed("exceededSize", file)
                            ];
                        }
                        setUploadedFile(file);
                        _tmp = [
                            scopeToUpload,
                            file.type
                        ];
                        return [
                            4,
                            handleConvertFileToBase64(file)
                        ];
                    case 1:
                        handleUploadFileToCloud.apply(void 0, _tmp.concat(_state.sent(), file.name, file.size));
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setUploadedFile,
        handleUploadFileToCloud,
        scopeToUpload,
        uploadFailed
    ]);
    function handleConvertFileToBase64(file) {
        return _handleConvertFileToBase64.apply(this, arguments);
    }
    function _handleConvertFileToBase64() {
        _handleConvertFileToBase64 = (0,_async_to_generator/* default */.Z)(function(file) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    new Promise(function(resolve, reject) {
                        var fileReader = new FileReader();
                        fileReader.readAsDataURL(file);
                        fileReader.onload = function() {
                            var result = fileReader.result;
                            var base64 = result.split(",")[1];
                            resolve(base64);
                        };
                        fileReader.onerror = function() {
                            reject(fileReader.result);
                        };
                    })
                ];
            });
        });
        return _handleConvertFileToBase64.apply(this, arguments);
    }
    if (!uploadedFile && !uploadStatus && !hasErrorOnUpload) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadFileInput, {
            ref: inputRef,
            handleInputClick: handleInputClick,
            handleFileUpload: handleFileUpload,
            acceptedTypes: acceptedTypes
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileCard, {
        type: uploadStatus,
        uploadedFile: uploadedFile,
        handleRemoveFile: removeFile
    });
}

// EXTERNAL MODULE: ./node_modules/zustand/esm/react.mjs + 1 modules
var esm_react = __webpack_require__(1993);
;// CONCATENATED MODULE: ./common/core-components/upload-file/use-upload-file.store.ts



var initialUploadState = {
    file: undefined,
    status: undefined,
    error: undefined,
    canProcess: false
};
var useUploadFileStore = (0,esm_react/* create */.U)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialUploadState), {
        setUploadedFile: function(file) {
            return set({
                file: file
            });
        },
        uploadOnGoing: function(file) {
            return set({
                file: file,
                status: "processing",
                canProcess: false
            });
        },
        uploadSuccess: function(file) {
            return set({
                file: file,
                status: "success",
                canProcess: true
            });
        },
        uploadFailed: function(error, file) {
            return set({
                file: file,
                status: error,
                error: error,
                canProcess: false
            });
        },
        removeFile: function() {
            return set(initialUploadState);
        }
    });
});

;// CONCATENATED MODULE: ./common/core-components/upload-file/use-upload-file.selector.ts

function useUploadFileState() {
    var uploadedFile = useUploadFileStore(function(state) {
        return state.file;
    });
    var uploadStatus = useUploadFileStore(function(state) {
        return state.status;
    });
    var hasErrorOnUpload = useUploadFileStore(function(state) {
        return state.error;
    });
    var canProcessUpload = useUploadFileStore(function(state) {
        return state.canProcess;
    });
    return {
        uploadedFile: uploadedFile,
        uploadStatus: uploadStatus,
        hasErrorOnUpload: hasErrorOnUpload,
        canProcessUpload: canProcessUpload
    };
}
function useUploadFileActions() {
    var setUploadedFile = useUploadFileStore(function(state) {
        return state.setUploadedFile;
    });
    var uploadOnGoing = useUploadFileStore(function(state) {
        return state.uploadOnGoing;
    });
    var uploadSuccess = useUploadFileStore(function(state) {
        return state.uploadSuccess;
    });
    var uploadFailed = useUploadFileStore(function(state) {
        return state.uploadFailed;
    });
    var removeFile = useUploadFileStore(function(state) {
        return state.removeFile;
    });
    return {
        setUploadedFile: setUploadedFile,
        uploadOnGoing: uploadOnGoing,
        uploadSuccess: uploadSuccess,
        uploadFailed: uploadFailed,
        removeFile: removeFile
    };
}

;// CONCATENATED MODULE: ./common/core-components/upload-file/index.ts



;// CONCATENATED MODULE: ./common/core-components/index.ts
























/***/ }),

/***/ 756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ ModalProvider; },
/* harmony export */   "Sq": function() { return /* binding */ ModalOpenButton; },
/* harmony export */   "dd": function() { return /* binding */ useModal; },
/* harmony export */   "hz": function() { return /* binding */ ModalContent; },
/* harmony export */   "ol": function() { return /* binding */ ModalCloseButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _common_ui_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8389);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5301);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);





function callAll() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++){
        functions[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        functions.forEach(function(fn) {
            if (fn) {
                fn.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(args));
            }
        });
    };
}
var ModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)({
    isOpen: false,
    setIsOpen: _utils__WEBPACK_IMPORTED_MODULE_2__/* .noop */ .ZT,
    onClose: _utils__WEBPACK_IMPORTED_MODULE_2__/* .noop */ .ZT
});
var useModal = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(ModalContext);
};
function ModalProvider(param) {
    var children = param.children, _onClose = param.onClose, onClose = _onClose === void 0 ? _utils__WEBPACK_IMPORTED_MODULE_2__/* .noop */ .ZT : _onClose;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var memoizedValues = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return {
            isOpen: isOpen,
            setIsOpen: setIsOpen,
            onClose: onClose
        };
    }, [
        isOpen,
        setIsOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContext.Provider, {
        value: memoizedValues,
        children: children
    });
}
function ModalCloseButton(param) {
    var children = param.children;
    var ref = useModal(), setIsOpen = ref.setIsOpen, onClose = ref.onClose;
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.cloneElement)(children, {
        onClick: callAll(function() {
            setIsOpen(false);
            onClose();
        }, children.props.onClick)
    });
}
function ModalOpenButton(param) {
    var children = param.children;
    var setIsOpen = useModal().setIsOpen;
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.cloneElement)(children, {
        onClick: callAll(function() {
            return setIsOpen(true);
        }, children.props.onClick)
    });
}
function Modal(param) {
    var children = param.children;
    var handleCloseModal = function handleCloseModal() {
        setIsOpen(false);
        onClose();
    };
    var ref = useModal(), isOpen = ref.isOpen, setIsOpen = ref.setIsOpen, onClose = ref.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_ui_components__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
        isOpen: isOpen,
        onClose: handleCloseModal,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_ui_components__WEBPACK_IMPORTED_MODULE_1__/* .ModalOverlay */ .ZA, {}),
            children
        ]
    });
}
function ModalContent(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_ui_components__WEBPACK_IMPORTED_MODULE_1__/* .ModalContent */ .hz, {
            children: children
        })
    });
}



/***/ }),

/***/ 5358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ MultiSelect; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./common/ui-components/index.ts + 730 modules
var ui_components = __webpack_require__(8389);
// EXTERNAL MODULE: ./utils/index.ts + 32 modules
var utils = __webpack_require__(5301);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./common/core-components/multi-select/multi-select.constants.ts
var ALL_VALUES_OPTION = {
    value: "*",
    label: ""
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./common/core-components/multi-select/multi-value/multi-value.tsx




function MultiValue(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* MultiValue */.X4, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: props.data.label
    }));
}

;// CONCATENATED MODULE: ./common/core-components/multi-select/multi-value/index.ts


;// CONCATENATED MODULE: ./common/core-components/multi-select/option/option.tsx





function Option(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Option */.Wx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
            gap: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "checkbox",
                    checked: props.isSelected,
                    onChange: utils/* noop */.ZT
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    children: props.label
                })
            ]
        })
    }));
}

;// CONCATENATED MODULE: ./common/core-components/multi-select/option/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./common/core-components/multi-select/value-container/value-container.tsx






function ValueContainer(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var currentValues = props.getValue();
    var child = children;
    var isAllValuesSelected = currentValues.some(function(data) {
        return data.value === ALL_VALUES_OPTION.value;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* ValueContainer */.K7, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Flex */.kC, {
            children: isAllValuesSelected ? [
                [
                    child[0][0]
                ],
                child[1]
            ] : children
        })
    }));
}

;// CONCATENATED MODULE: ./common/core-components/multi-select/value-container/index.ts


;// CONCATENATED MODULE: ./common/core-components/multi-select/multi-select.tsx









function MultiSelect(param) {
    var placeholder = param.placeholder, _allValuesLabel = param.allValuesLabel, allValuesLabel = _allValuesLabel === void 0 ? ALL_VALUES_OPTION.label : _allValuesLabel, noOptionsLabel = param.noOptionsLabel, name = param.name, _onChange = param.onChange, onChange = _onChange === void 0 ? utils/* noop */.ZT : _onChange, options = param.options, value = param.value;
    var allValues = (0,react.useMemo)(function() {
        return {
            label: allValuesLabel,
            value: ALL_VALUES_OPTION.value
        };
    }, [
        allValuesLabel
    ]);
    var ref = (0,react.useState)(null), selectedValues = ref[0], setSelectedValue = ref[1];
    (0,react.useEffect)(function() {
        if (value === null || value === undefined || value.length === 0) {
            setSelectedValue(null);
            return;
        }
        if (value.length === options.length) {
            setSelectedValue([
                allValues
            ].concat((0,_to_consumable_array/* default */.Z)(options)));
            return;
        }
        setSelectedValue(value);
    }, [
        allValues,
        options,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* MultiSelect */.NU, {
        name: name,
        isMulti: true,
        options: options.length ? [
            allValues
        ].concat((0,_to_consumable_array/* default */.Z)(options)) : options,
        placeholder: placeholder,
        noOptionsMessage: function() {
            return noOptionsLabel;
        },
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        useBasicStyles: true,
        components: {
            Option: Option,
            MultiValue: MultiValue,
            ValueContainer: ValueContainer
        },
        value: selectedValues,
        onChange: function(selected, event) {
            if (event.action === "deselect-option" && event.option.value === allValues.value || event.action === "remove-value" && event.removedValue.value === allValues.value) {
                setSelectedValue(null);
                onChange(null);
                return;
            }
            if (event.action === "deselect-option" && selected.length === options.length) {
                var newValue = options.filter(function(item) {
                    return item.value === event.option.value;
                });
                setSelectedValue(newValue);
                onChange(newValue);
                return;
            }
            if (selected.length && (selected.length === options.length || selected.find(function(option) {
                return option.value === allValues.value;
            }))) {
                setSelectedValue([
                    allValues
                ].concat((0,_to_consumable_array/* default */.Z)(options)));
                onChange(options);
                return;
            }
            setSelectedValue(selected);
            onChange(selected);
        }
    });
}

;// CONCATENATED MODULE: ./common/core-components/multi-select/index.ts



/***/ }),

/***/ 7646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qN": function() { return /* reexport */ CreateOrEditTripProvider; },
  "MI": function() { return /* reexport */ SelectHubAndDateToCreateTripProvider; },
  "Xv": function() { return /* reexport */ useCreateOrEditTrip; },
  "JL": function() { return /* reexport */ useSelectHubAndDateToCreateTrip; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./common/ui-components/index.ts + 730 modules
var ui_components = __webpack_require__(8389);
// EXTERNAL MODULE: ./utils/index.ts + 32 modules
var utils = __webpack_require__(5301);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./modules/trips/use-cases/index.ts + 20 modules
var use_cases = __webpack_require__(1550);
;// CONCATENATED MODULE: ./modules/trips/contexts/create-or-edit-trip/use-create-or-edit-trip.tsx






var CreateOrEditTripContext = /*#__PURE__*/ (0,react.createContext)({
    data: {
        selectedRiderId: "",
        rider: null,
        trip: null,
        selectedDeliveries: [],
        addedDeliveriesToTrip: [],
        shouldSuspendTripUpdates: false
    },
    actions: {
        setSelectedRiderId: utils/* noop */.ZT,
        setRider: utils/* noop */.ZT,
        setSelectedDeliveries: utils/* noop */.ZT,
        setAddedDeliveriesToTrip: utils/* noop */.ZT,
        handleSuspendTripUpdates: utils/* noop */.ZT,
        onCloseTripAlreadyStartedModal: utils/* noop */.ZT
    },
    isTripLoading: false,
    hasErrorOnTrip: undefined
});
var CreateOrEditTripProvider = function(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var ref = (0,ui_components/* useDisclosure */.qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var tripId = router === null || router === void 0 ? void 0 : router.query.tripId;
    var ref1 = (0,use_cases/* useGetTrip */.MZ)({
        id: tripId
    }), trip = ref1.data, loading = ref1.loading, error = ref1.error;
    var ref2 = (0,react.useState)(""), selectedRiderId = ref2[0], setSelectedRiderId = ref2[1];
    var ref3 = (0,react.useState)(null), rider = ref3[0], setRider = ref3[1];
    var ref4 = (0,react.useState)([]), selectedDeliveries = ref4[0], setSelectedDeliveries = ref4[1];
    var ref5 = (0,react.useState)([]), addedDeliveriesToTrip = ref5[0], setAddedDeliveriesToTrip = ref5[1];
    var contextValue = (0,react.useMemo)(function() {
        return {
            data: {
                selectedRiderId: selectedRiderId,
                trip: trip,
                rider: rider,
                selectedDeliveries: selectedDeliveries,
                addedDeliveriesToTrip: addedDeliveriesToTrip,
                shouldSuspendTripUpdates: isOpen
            },
            actions: {
                setSelectedRiderId: setSelectedRiderId,
                setRider: setRider,
                setSelectedDeliveries: setSelectedDeliveries,
                setAddedDeliveriesToTrip: setAddedDeliveriesToTrip,
                handleSuspendTripUpdates: onOpen,
                onCloseTripAlreadyStartedModal: onClose
            },
            isTripLoading: loading,
            hasErrorOnTrip: error
        };
    }, [
        selectedRiderId,
        trip,
        rider,
        selectedDeliveries,
        addedDeliveriesToTrip,
        isOpen,
        setSelectedRiderId,
        setRider,
        setSelectedDeliveries,
        setAddedDeliveriesToTrip,
        onOpen,
        onClose,
        loading,
        error, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateOrEditTripContext.Provider, {
        value: contextValue,
        children: children
    });
};
var useCreateOrEditTrip = function() {
    return (0,react.useContext)(CreateOrEditTripContext);
};

;// CONCATENATED MODULE: ./modules/trips/contexts/create-or-edit-trip/index.ts


;// CONCATENATED MODULE: ./modules/trips/contexts/select-hub-and-date-to-create-trip/use-select-hub-and-date-to-create-trip.tsx




var SelectHubAndDateToCreateTripContext = /*#__PURE__*/ (0,react.createContext)({
    drawer: {
        isDrawerOpen: false,
        onDrawerOpen: utils/* noop */.ZT,
        onDrawerClose: utils/* noop */.ZT
    },
    data: {
        selectedHubId: "",
        selectedDate: ""
    },
    actions: {
        setSelectedHubId: utils/* noop */.ZT,
        setSelectedDate: utils/* noop */.ZT
    }
});
var SelectHubAndDateToCreateTripProvider = function(param) {
    var children = param.children;
    var ref = (0,ui_components/* useDisclosure */.qY)(), isDrawerOpen = ref.isOpen, onDrawerOpen = ref.onOpen, onDrawerClose = ref.onClose;
    var ref1 = (0,react.useState)(""), selectedHubId = ref1[0], setSelectedHubId = ref1[1];
    var ref2 = (0,react.useState)(""), selectedDate = ref2[0], setSelectedDate = ref2[1];
    var contextValue = (0,react.useMemo)(function() {
        return {
            drawer: {
                isDrawerOpen: isDrawerOpen,
                onDrawerOpen: onDrawerOpen,
                onDrawerClose: onDrawerClose
            },
            data: {
                selectedHubId: selectedHubId,
                selectedDate: selectedDate
            },
            actions: {
                setSelectedHubId: setSelectedHubId,
                setSelectedDate: setSelectedDate
            }
        };
    }, [
        isDrawerOpen,
        onDrawerOpen,
        onDrawerClose,
        selectedHubId,
        selectedDate,
        setSelectedHubId,
        setSelectedDate, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectHubAndDateToCreateTripContext.Provider, {
        value: contextValue,
        children: children
    });
};
var useSelectHubAndDateToCreateTrip = function() {
    return (0,react.useContext)(SelectHubAndDateToCreateTripContext);
};

;// CONCATENATED MODULE: ./modules/trips/contexts/select-hub-and-date-to-create-trip/index.ts


;// CONCATENATED MODULE: ./modules/trips/contexts/index.ts




/***/ }),

/***/ 1550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_8": function() { return /* reexport */ ALL_TRIPS_TAB; },
  "D5": function() { return /* reexport */ useCreateTrip; },
  "YZ": function() { return /* reexport */ useGetAllTrips; },
  "K8": function() { return /* reexport */ useGetExternalRiderJourneysForTrip; },
  "MZ": function() { return /* reexport */ useGetTrip; },
  "Fk": function() { return /* reexport */ useUndoTrip; },
  "il": function() { return /* reexport */ useUpdateTripPoints; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./common/bff/index.ts + 34 modules
var bff = __webpack_require__(7470);
// EXTERNAL MODULE: ./common/core-components/index.ts + 89 modules
var core_components = __webpack_require__(3937);
// EXTERNAL MODULE: ./common/i18n/index.ts + 17 modules
var i18n = __webpack_require__(2948);
// EXTERNAL MODULE: ./common/observability/index.ts + 145 modules
var observability = __webpack_require__(6137);
// EXTERNAL MODULE: ./modules/trips/intl/index.ts + 3 modules
var intl = __webpack_require__(8709);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./modules/trips/use-cases/create-trip/create-trip.mutation.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation TripModule_CreateTrip(\n    $deliveryIds: [String!]!\n    $mode: TripMode!\n    $originType: TripOriginType!\n    $riderId: String\n  ) {\n    createTrip(\n      deliveryIds: $deliveryIds\n      mode: $mode\n      originType: $originType\n      riderId: $riderId\n    )\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CREATE_TRIP = (0,bff/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./modules/trips/use-cases/create-trip/use-create-trip.ts









function useCreateTrip() {
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var onLoadingToast = (0,core_components/* useOnLoadingToast */.dV)();
    var onTripCreatedToast = (0,core_components/* useOnSuccessToast */.kK)({
        title: formatMessage({
            id: intl/* tripsIntlIds.tripsList.toasts.onSuccess.title */.CJ.tripsList.toasts.onSuccess.title
        }),
        description: formatMessage({
            id: intl/* tripsIntlIds.tripsList.toasts.onSuccess.description */.CJ.tripsList.toasts.onSuccess.description
        })
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,bff/* useMutation */.Db)(CREATE_TRIP, {
        onCompleted: function(content) {
            observability/* hermesLogger.info */.t.info("[CreateTrip] Trip creation successfully processed", content);
            onTripCreatedToast();
        },
        onError: function(error) {
            observability/* hermesLogger.error */.t.error("[CreateTrip] Error processing Trip creation", {
                timestamp: new Date(),
                error: {
                    stack: error.stack,
                    message: error.message,
                    kind: error.name
                }
            });
        }
    }), 2), handleCreateTrip = ref[0], ref1 = ref[1], data = ref1.data, loading = ref1.loading, error = ref1.error;
    function createTrip(_) {
        return _createTrip.apply(this, arguments);
    }
    function _createTrip() {
        _createTrip = (0,_async_to_generator/* default */.Z)(function(param) {
            var deliveryIds, mode, originType, riderId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                deliveryIds = param.deliveryIds, mode = param.mode, originType = param.originType, riderId = param.riderId;
                onLoadingToast();
                return [
                    2,
                    handleCreateTrip({
                        variables: {
                            deliveryIds: deliveryIds,
                            mode: mode,
                            originType: originType,
                            riderId: riderId
                        }
                    })
                ];
            });
        });
        return _createTrip.apply(this, arguments);
    }
    return {
        actions: {
            createTrip: createTrip
        },
        data: data === null || data === void 0 ? void 0 : data.createTrip,
        loading: loading,
        error: error
    };
}

;// CONCATENATED MODULE: ./modules/trips/use-cases/create-trip/index.ts


// EXTERNAL MODULE: ./types/index.ts + 1 modules
var types = __webpack_require__(8910);
;// CONCATENATED MODULE: ./modules/trips/use-cases/get-all-trips/get-all-trips.constants.ts

var ALL_TRIPS_STATUSES = [
    types/* TripStatus.Pending */.aU.Pending,
    types/* TripStatus.Started */.aU.Started,
    types/* TripStatus.Completed */.aU.Completed,
    types/* TripStatus.Canceled */.aU.Canceled, 
];
var ALL_TRIPS_TAB = "all";

// EXTERNAL MODULE: ./use-cases/utils/constants.ts
var constants = __webpack_require__(4854);
;// CONCATENATED MODULE: ./modules/trips/use-cases/get-all-trips/get-all-trips.query.ts

function get_all_trips_query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TripModule_GetAllTrips(\n    $hubIds: [String!]\n    $statuses: [TripStatus!]\n    $originType: TripOriginType\n    $offset: Int = ",
        "\n    $limit: Int = ",
        "\n  ) {\n    tripsPaginated(hubIds: $hubIds, statuses: $statuses, originType: $originType, offset: $offset, limit: $limit) {\n      limit\n      offset\n      totalCount\n      trips {\n        id\n        mode\n        status\n        plannedTo\n        points {\n          hubs {\n            id\n            alias\n          }\n          deliveries {\n            id\n            status\n          }\n        }\n        rider {\n          id\n          fullName\n          isExternal\n        }\n      }\n    }\n  }\n"
    ]);
    get_all_trips_query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GET_ALL_TRIPS = (0,bff/* gql */.Ps)(get_all_trips_query_templateObject(), constants/* DEFAULT_LIST_OFFSET */.I, constants/* DEFAULT_LIST_LIMIT */._);

;// CONCATENATED MODULE: ./modules/trips/use-cases/get-all-trips/use-get-all-trips.ts




function useGetAllTrips(param) {
    var _hubIds = param.hubIds, hubIds = _hubIds === void 0 ? [] : _hubIds, _statuses = param.statuses, statuses = _statuses === void 0 ? ALL_TRIPS_STATUSES : _statuses, originType = param.originType, limit = param.limit, offset = param.offset, _poll = param.poll, poll = _poll === void 0 ? false : _poll;
    var ref = (0,bff/* useQuery */.aM)(GET_ALL_TRIPS, {
        variables: {
            hubIds: hubIds,
            statuses: statuses,
            originType: originType,
            limit: limit,
            offset: offset
        },
        pollInterval: poll ? 4000 : undefined,
        onCompleted: function(content) {
            observability/* hermesLogger.info */.t.info("[GetAllTrips] Successfully retrieved all Trips", content);
        },
        onError: function(error) {
            observability/* hermesLogger.error */.t.error("[GetAllTrips] Error getting all Trips", {
                timestamp: new Date(),
                error: {
                    stack: error.stack,
                    message: error.message,
                    kind: error.name
                }
            });
        }
    }), data = ref.data, loading = ref.loading, error = ref.error;
    return {
        data: data === null || data === void 0 ? void 0 : data.tripsPaginated,
        loading: loading,
        error: error
    };
}

;// CONCATENATED MODULE: ./modules/trips/use-cases/get-all-trips/index.ts



;// CONCATENATED MODULE: ./modules/trips/use-cases/get-external-rider-journeys-for-trip/get-external-rider-journeys-for-trip.query.ts

function get_external_rider_journeys_for_trip_query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query JourneyModule_GetExternalRiderJourneysForTrip(\n    $hubId: String!\n    $tripId: String\n  ) {\n    getExternalRiderJourneysForTrip(hubId: $hubId, tripId: $tripId) {\n      rider {\n        id\n        fullName\n      }\n    }\n  }\n"
    ]);
    get_external_rider_journeys_for_trip_query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var GET_EXTERNAL_RIDER_JOURNEYS_FOR_TRIP = (0,bff/* gql */.Ps)(get_external_rider_journeys_for_trip_query_templateObject());

;// CONCATENATED MODULE: ./modules/trips/use-cases/get-external-rider-journeys-for-trip/use-get-external-rider-journeys-for-trip.ts




function useGetExternalRiderJourneysForTrip(param) {
    var hubId = param.hubId, tripId = param.tripId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,bff/* useLazyQuery */.td)(GET_EXTERNAL_RIDER_JOURNEYS_FOR_TRIP, {
        variables: {
            tripId: tripId,
            hubId: hubId
        },
        fetchPolicy: "no-cache",
        onCompleted: function(content) {
            observability/* hermesLogger.info */.t.info("[GetExternalRiderJourneys] Successfully retrieved all Journeys for Trip", content);
        },
        onError: function(error) {
            observability/* hermesLogger.error */.t.error("[GetExternalRiderJourneys] Error getting Journeys for Trip", {
                timestamp: new Date(),
                error: {
                    stack: error.stack,
                    message: error.message,
                    kind: error.name
                }
            });
        }
    }), 2), getJourneys = ref[0], ref1 = ref[1], data = ref1.data, loading = ref1.loading, error = ref1.error;
    return {
        actions: {
            getJourneys: function(hubId, tripId) {
                getJourneys({
                    variables: {
                        hubId: hubId,
                        tripId: tripId
                    }
                });
            }
        },
        data: data === null || data === void 0 ? void 0 : data.getExternalRiderJourneysForTrip,
        loading: loading,
        error: error
    };
}

;// CONCATENATED MODULE: ./modules/trips/use-cases/get-external-rider-journeys-for-trip/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./modules/trips/use-cases/get-trip/get-trip.query.ts

function get_trip_query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TripModule_GetTrip($id: String!) {\n    trip(id: $id) {\n      id\n      mode\n      status\n      originType\n      plannedTo\n      points {\n        hubs {\n          id\n          alias\n        }\n      }\n      rider {\n        id\n        fullName\n        isExternal\n      }\n      deliveries {\n        id\n        status\n        assortmentType\n        etaMin\n        etaMax\n        hub {\n          id\n          alias\n        }\n        order {\n          id\n        }\n        customer {\n          address {\n            formatted\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    get_trip_query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var GET_TRIP = (0,bff/* gql */.Ps)(get_trip_query_templateObject());

;// CONCATENATED MODULE: ./modules/trips/use-cases/get-trip/trip-updated.subscription.ts

function trip_updated_subscription_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  subscription TripModule_TripUpdated($id: String!) {\n    tripUpdated(id: $id) {\n      mode\n      status\n      plannedTo\n      points {\n        hubs {\n          id\n          alias\n        }\n      }\n      rider {\n        id\n        fullName\n        isExternal\n      }\n      deliveries {\n        id\n        status\n        assortmentType\n        etaMin\n        etaMax\n        order {\n          id\n        }\n        hub {\n          id\n          alias\n        }\n        customer {\n          address {\n            formatted\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    trip_updated_subscription_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var TRIP_UPDATED_SUBSCRIPTION = (0,bff/* gql */.Ps)(trip_updated_subscription_templateObject());

;// CONCATENATED MODULE: ./modules/trips/use-cases/get-trip/use-get-trip.ts







function useGetTrip(param) {
    var id = param.id;
    var ref = (0,bff/* useQuery */.aM)(GET_TRIP, {
        variables: {
            id: id
        },
        skip: !id,
        onCompleted: function(content) {
            observability/* hermesLogger.info */.t.info("[GetTrip] Successfully retrieved Trip ".concat(id), content);
        },
        onError: function(error) {
            observability/* hermesLogger.error */.t.error("[GetTrip] Error getting Trip ".concat(id), {
                timestamp: new Date(),
                error: {
                    stack: error.stack,
                    message: error.message,
                    kind: error.name
                }
            });
        }
    }), data = ref.data, loading = ref.loading, error = ref.error, subscribeToMore = ref.subscribeToMore;
    (0,react.useEffect)(function() {
        if (!id) return;
        var unsubscribe = subscribeToMore({
            document: TRIP_UPDATED_SUBSCRIPTION,
            variables: {
                id: id
            },
            updateQuery: function(prev, param) {
                var subscriptionData = param.subscriptionData;
                if (!subscriptionData.data) return prev;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    trip: (0,_object_spread/* default */.Z)({}, subscriptionData.data.tripUpdated)
                });
            }
        });
        return function() {
            return unsubscribe();
        };
    }, [
        subscribeToMore,
        id
    ]);
    return {
        data: data === null || data === void 0 ? void 0 : data.trip,
        loading: loading,
        error: error
    };
}

;// CONCATENATED MODULE: ./modules/trips/use-cases/get-trip/index.ts


;// CONCATENATED MODULE: ./modules/trips/use-cases/undo-trip/undo-trip.mutation.ts

function undo_trip_mutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation TripModule_UndoTrip($tripId: String!) {\n    undoTrip(tripId: $tripId)\n  }\n"
    ]);
    undo_trip_mutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var UNDO_TRIP = (0,bff/* gql */.Ps)(undo_trip_mutation_templateObject());

;// CONCATENATED MODULE: ./modules/trips/use-cases/undo-trip/use-undo-trip.ts









function useUndoTrip(param) {
    var tripId = param.tripId;
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var onLoadingToast = (0,core_components/* useOnLoadingToast */.dV)();
    var onTripUndoneToast = (0,core_components/* useOnWarningToast */.FV)({
        title: formatMessage({
            id: intl/* tripsIntlIds.tripsList.toasts.onWarning.title */.CJ.tripsList.toasts.onWarning.title
        }, {
            tripId: tripId
        }),
        description: formatMessage({
            id: intl/* tripsIntlIds.tripsList.toasts.onWarning.description */.CJ.tripsList.toasts.onWarning.description
        })
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,bff/* useMutation */.Db)(UNDO_TRIP, {
        onCompleted: function(content) {
            observability/* hermesLogger.info */.t.info("[UndoTrip] Trip undo sucessfully processed", content);
            onTripUndoneToast();
        },
        onError: function(error) {
            observability/* hermesLogger.error */.t.error("[UndoTrip] Error processing Trip undo", {
                timestamp: new Date(),
                error: {
                    stack: error.stack,
                    message: error.message,
                    kind: error.name
                }
            });
        }
    }), 2), handleUndoTrip = ref[0], ref1 = ref[1], data = ref1.data, loading = ref1.loading, error = ref1.error;
    function undoTrip(tripId) {
        return _undoTrip.apply(this, arguments);
    }
    function _undoTrip() {
        _undoTrip = (0,_async_to_generator/* default */.Z)(function(tripId) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                onLoadingToast();
                return [
                    2,
                    handleUndoTrip({
                        variables: {
                            tripId: tripId
                        }
                    })
                ];
            });
        });
        return _undoTrip.apply(this, arguments);
    }
    return {
        actions: {
            undoTrip: undoTrip
        },
        data: data === null || data === void 0 ? void 0 : data.undoTrip,
        loading: loading,
        error: error
    };
}

;// CONCATENATED MODULE: ./modules/trips/use-cases/undo-trip/index.ts


;// CONCATENATED MODULE: ./modules/trips/use-cases/update-trip-points/update-trip-points.mutation.ts

function update_trip_points_mutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation TripModule_UpdateTripPoints(\n    $tripId: String!\n    $deliveryIds: [String!]!\n  ) {\n    updateTripPoints(tripId: $tripId, deliveryIds: $deliveryIds)\n  }\n"
    ]);
    update_trip_points_mutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var EDIT_TRIP = (0,bff/* gql */.Ps)(update_trip_points_mutation_templateObject());

;// CONCATENATED MODULE: ./modules/trips/use-cases/update-trip-points/use-update-trip-points.ts









function useUpdateTripPoints() {
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var onLoadingToast = (0,core_components/* useOnLoadingToast */.dV)();
    var onUpdatedTripPointsToast = (0,core_components/* useOnSuccessToast */.kK)({
        title: formatMessage({
            id: intl/* tripsIntlIds.tripDetails.toasts.onTripUpdatedSuccess.title */.CJ.tripDetails.toasts.onTripUpdatedSuccess.title
        })
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,bff/* useMutation */.Db)(EDIT_TRIP, {
        onCompleted: function(content) {
            observability/* hermesLogger.info */.t.info("[UpdateTripPoints] Trip update points sucessfully processed", content);
            onUpdatedTripPointsToast();
        },
        onError: function(error) {
            observability/* hermesLogger.error */.t.error("[UpdateTripPoints] Error processing Trip update points", {
                timestamp: new Date(),
                error: {
                    stack: error.stack,
                    message: error.message,
                    kind: error.name
                }
            });
        }
    }), 2), handleUpdateTripPoints = ref[0], ref1 = ref[1], data = ref1.data, loading = ref1.loading, error = ref1.error;
    function updateTripPoints(tripId, deliveryIds) {
        return _updateTripPoints.apply(this, arguments);
    }
    function _updateTripPoints() {
        _updateTripPoints = (0,_async_to_generator/* default */.Z)(function(tripId, deliveryIds) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                onLoadingToast();
                return [
                    2,
                    handleUpdateTripPoints({
                        variables: {
                            tripId: tripId,
                            deliveryIds: deliveryIds
                        }
                    })
                ];
            });
        });
        return _updateTripPoints.apply(this, arguments);
    }
    return {
        actions: {
            updateTripPoints: updateTripPoints
        },
        data: data === null || data === void 0 ? void 0 : data.updateTripPoints,
        loading: loading,
        error: error
    };
}

;// CONCATENATED MODULE: ./modules/trips/use-cases/update-trip-points/index.ts


;// CONCATENATED MODULE: ./modules/trips/use-cases/index.ts








/***/ }),

/***/ 8910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_r": function() { return /* reexport */ CancelExternalDispatchAgent; },
  "E9": function() { return /* reexport */ CancelExternalDispatchReason; },
  "Pe": function() { return /* reexport */ DeliveryAssortmentType; },
  "Nd": function() { return /* reexport */ DeliveryKind; },
  "$T": function() { return /* reexport */ DeliveryStatus; },
  "Nm": function() { return /* reexport */ Direction; },
  "CS": function() { return /* reexport */ DivulgationStatus; },
  "eZ": function() { return /* reexport */ ExternalDispatchStatus; },
  "h2": function() { return /* reexport */ JourneyStatus; },
  "Xj": function() { return /* reexport */ RequestExternalDispatchReason; },
  "b_": function() { return /* reexport */ RequestExternalDispatchSize; },
  "OE": function() { return /* reexport */ TripMode; },
  "vN": function() { return /* reexport */ TripOriginType; },
  "aU": function() { return /* reexport */ TripStatus; },
  "nl": function() { return /* reexport */ UserAccessType; }
});

// UNUSED EXPORTS: BookedSlotOriginOfAssign, JourneyActionName, JourneyActionStatus, Modality, RiderMedal

;// CONCATENATED MODULE: ./types/gql.d.ts
var BookedSlotOriginOfAssign;
(function(BookedSlotOriginOfAssign) {
    BookedSlotOriginOfAssign["AdminAssign"] = "admin_assign";
    BookedSlotOriginOfAssign["RiderSelfAssign"] = "rider_self_assign";
})(BookedSlotOriginOfAssign || (BookedSlotOriginOfAssign = {}));
var CancelExternalDispatchAgent;
(function(CancelExternalDispatchAgent) {
    CancelExternalDispatchAgent["Client"] = "Client";
    CancelExternalDispatchAgent["Internal"] = "Internal";
    CancelExternalDispatchAgent["Rider"] = "Rider";
})(CancelExternalDispatchAgent || (CancelExternalDispatchAgent = {}));
var CancelExternalDispatchReason;
(function(CancelExternalDispatchReason) {
    CancelExternalDispatchReason["ClientCancelation"] = "ClientCancelation";
    CancelExternalDispatchReason["ClientFraudNoOrder"] = "ClientFraudNoOrder";
    CancelExternalDispatchReason["ClientFraudNoReceive"] = "ClientFraudNoReceive";
    CancelExternalDispatchReason["ClientNoReceive"] = "ClientNoReceive";
    CancelExternalDispatchReason["ClientWrongInfo"] = "ClientWrongInfo";
    CancelExternalDispatchReason["InternalAvailableRider"] = "InternalAvailableRider";
    CancelExternalDispatchReason["InternalWaitTimeTooLong"] = "InternalWaitTimeTooLong";
    CancelExternalDispatchReason["InternalWrongRequest"] = "InternalWrongRequest";
    CancelExternalDispatchReason["RiderAddressNotFound"] = "RiderAddressNotFound";
    CancelExternalDispatchReason["RiderClientNotFound"] = "RiderClientNotFound";
    CancelExternalDispatchReason["RiderFraud"] = "RiderFraud";
    CancelExternalDispatchReason["RiderRiskArea"] = "RiderRiskArea";
    CancelExternalDispatchReason["RiderUnexpected"] = "RiderUnexpected";
})(CancelExternalDispatchReason || (CancelExternalDispatchReason = {}));
var DeliveryAssortmentType;
(function(DeliveryAssortmentType) {
    DeliveryAssortmentType["Core"] = "core";
    DeliveryAssortmentType["Plus"] = "plus";
    DeliveryAssortmentType["Unknown"] = "unknown";
})(DeliveryAssortmentType || (DeliveryAssortmentType = {}));
var DeliveryKind;
(function(DeliveryKind) {
    DeliveryKind["Instant"] = "instant";
    DeliveryKind["Scheduled"] = "scheduled";
    DeliveryKind["Unknown"] = "unknown";
})(DeliveryKind || (DeliveryKind = {}));
var DeliveryStatus;
(function(DeliveryStatus) {
    DeliveryStatus["Arrived"] = "arrived";
    DeliveryStatus["Canceled"] = "canceled";
    DeliveryStatus["Delivered"] = "delivered";
    DeliveryStatus["InManualAnalysis"] = "in_manual_analysis";
    DeliveryStatus["OnTheWay"] = "on_the_way";
    DeliveryStatus["Pending"] = "pending";
    DeliveryStatus["Picking"] = "picking";
    DeliveryStatus["PreProcessed"] = "pre_processed";
    DeliveryStatus["Processed"] = "processed";
    DeliveryStatus["Ready"] = "ready";
    DeliveryStatus["Unknown"] = "unknown";
})(DeliveryStatus || (DeliveryStatus = {}));
var Direction;
(function(Direction) {
    Direction["Asc"] = "Asc";
    Direction["Desc"] = "Desc";
})(Direction || (Direction = {}));
var DivulgationStatus;
(function(DivulgationStatus) {
    DivulgationStatus["Created"] = "created";
    DivulgationStatus["Failed"] = "failed";
    DivulgationStatus["Planned"] = "planned";
})(DivulgationStatus || (DivulgationStatus = {}));
var ExternalDispatchStatus;
(function(ExternalDispatchStatus) {
    ExternalDispatchStatus["Arrived"] = "arrived";
    ExternalDispatchStatus["Canceled"] = "canceled";
    ExternalDispatchStatus["Delivered"] = "delivered";
    ExternalDispatchStatus["Failed"] = "failed";
    ExternalDispatchStatus["OnTheWay"] = "on_the_way";
    ExternalDispatchStatus["Pending"] = "pending";
    ExternalDispatchStatus["Returned"] = "returned";
    ExternalDispatchStatus["Returning"] = "returning";
    ExternalDispatchStatus["RiderAssigned"] = "rider_assigned";
    ExternalDispatchStatus["Unknown"] = "unknown";
})(ExternalDispatchStatus || (ExternalDispatchStatus = {}));
var JourneyActionName;
(function(JourneyActionName) {
    JourneyActionName["Cancel"] = "cancel";
    JourneyActionName["Expire"] = "expire";
    JourneyActionName["Finish"] = "finish";
    JourneyActionName["Pause"] = "pause";
    JourneyActionName["Resume"] = "resume";
    JourneyActionName["Start"] = "start";
    JourneyActionName["Unknown"] = "unknown";
})(JourneyActionName || (JourneyActionName = {}));
var JourneyActionStatus;
(function(JourneyActionStatus) {
    JourneyActionStatus["Canceled"] = "canceled";
    JourneyActionStatus["Completed"] = "completed";
    JourneyActionStatus["Failed"] = "failed";
    JourneyActionStatus["Processing"] = "processing";
    JourneyActionStatus["Unknown"] = "unknown";
})(JourneyActionStatus || (JourneyActionStatus = {}));
var JourneyStatus;
(function(JourneyStatus) {
    JourneyStatus["Available"] = "available";
    JourneyStatus["Canceled"] = "canceled";
    JourneyStatus["InRoute"] = "inRoute";
    JourneyStatus["Offline"] = "offline";
    JourneyStatus["Paused"] = "paused";
    JourneyStatus["Pending"] = "pending";
    JourneyStatus["Unknown"] = "unknown";
})(JourneyStatus || (JourneyStatus = {}));
var Modality;
(function(Modality) {
    Modality["Bicycle"] = "bicycle";
    Modality["Motorcycle"] = "motorcycle";
})(Modality || (Modality = {}));
var RequestExternalDispatchReason;
(function(RequestExternalDispatchReason) {
    RequestExternalDispatchReason["Distance"] = "Distance";
    RequestExternalDispatchReason["LargeOrder"] = "LargeOrder";
    RequestExternalDispatchReason["NoRiders"] = "NoRiders";
    RequestExternalDispatchReason["Rain"] = "Rain";
    RequestExternalDispatchReason["Strike"] = "Strike";
})(RequestExternalDispatchReason || (RequestExternalDispatchReason = {}));
var RequestExternalDispatchSize;
(function(RequestExternalDispatchSize) {
    RequestExternalDispatchSize["Large"] = "Large";
    RequestExternalDispatchSize["Medium"] = "Medium";
    RequestExternalDispatchSize["Small"] = "Small";
    RequestExternalDispatchSize["XLarge"] = "XLarge";
})(RequestExternalDispatchSize || (RequestExternalDispatchSize = {}));
var RiderMedal;
(function(RiderMedal) {
    RiderMedal["Bronze"] = "bronze";
    RiderMedal["Gold"] = "gold";
    RiderMedal["Silver"] = "silver";
})(RiderMedal || (RiderMedal = {}));
var TripMode;
(function(TripMode) {
    TripMode["Automatic"] = "automatic";
    TripMode["External"] = "external";
    TripMode["Manual"] = "manual";
})(TripMode || (TripMode = {}));
var TripOriginType;
(function(TripOriginType) {
    TripOriginType["AutomaticallyCreatedAndPlanned"] = "automatically_created_and_planned";
    TripOriginType["ManuallyCreatedAndAutomaticallyPlanned"] = "manually_created_and_automatically_planned";
    TripOriginType["ManuallyCreatedAndPlanned"] = "manually_created_and_planned";
})(TripOriginType || (TripOriginType = {}));
var TripStatus;
(function(TripStatus) {
    TripStatus["Canceled"] = "canceled";
    TripStatus["Completed"] = "completed";
    TripStatus["Pending"] = "pending";
    TripStatus["Started"] = "started";
    TripStatus["Unknown"] = "unknown";
    TripStatus["Voided"] = "voided";
})(TripStatus || (TripStatus = {}));
var UserAccessType;
(function(UserAccessType) {
    UserAccessType["Admin"] = "Admin";
    UserAccessType["Ct"] = "CT";
    UserAccessType["H"] = "H";
    UserAccessType["Ro"] = "RO";
    UserAccessType["Unknown"] = "unknown";
})(UserAccessType || (UserAccessType = {}));

;// CONCATENATED MODULE: ./types/index.ts



/***/ }),

/***/ 4854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ DEFAULT_LIST_OFFSET; },
/* harmony export */   "_": function() { return /* binding */ DEFAULT_LIST_LIMIT; }
/* harmony export */ });
var DEFAULT_LIST_LIMIT = 48;
var DEFAULT_LIST_OFFSET = 0;


/***/ })

}]);